/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedWelcomeRouteImport } from './routes/_authenticated/welcome'
import { Route as AuthenticatedSettingsV2RouteImport } from './routes/_authenticated/settings-v2'
import { Route as AuthenticatedMissionRouteImport } from './routes/_authenticated/mission'
import { Route as AuthenticatedMarketRouteImport } from './routes/_authenticated/market'
import { Route as AuthenticatedInboxRouteImport } from './routes/_authenticated/inbox'
import { Route as AuthenticatedFilesRouteImport } from './routes/_authenticated/files'
import { Route as AuthenticatedCommsRouteImport } from './routes/_authenticated/comms'
import { Route as AuthenticatedBoardsRouteImport } from './routes/_authenticated/boards'
import { Route as AuthenticatedUniversityIndexRouteImport } from './routes/_authenticated/university/index'
import { Route as AuthenticatedStrategyIndexRouteImport } from './routes/_authenticated/strategy/index'
import { Route as AuthenticatedPrinciplesIndexRouteImport } from './routes/_authenticated/principles/index'
import { Route as AuthenticatedMarketIndexRouteImport } from './routes/_authenticated/market/index'
import { Route as AuthenticatedGoalsIndexRouteImport } from './routes/_authenticated/goals/index'
import { Route as AuthenticatedDepartmentsIndexRouteImport } from './routes/_authenticated/departments/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedConstitutionIndexRouteImport } from './routes/_authenticated/constitution/index'
import { Route as AuthenticatedCompanyIndexRouteImport } from './routes/_authenticated/company/index'
import { Route as AuthenticatedCommsIndexRouteImport } from './routes/_authenticated/comms/index'
import { Route as AuthenticatedBrainIndexRouteImport } from './routes/_authenticated/brain/index'
import { Route as AuthenticatedArchitectIndexRouteImport } from './routes/_authenticated/architect/index'
import { Route as AuthenticatedUniversityPatternsRouteImport } from './routes/_authenticated/university/patterns'
import { Route as AuthenticatedSettingsWorkspaceRouteImport } from './routes/_authenticated/settings/workspace'
import { Route as AuthenticatedSettingsUsersRouteImport } from './routes/_authenticated/settings/users'
import { Route as AuthenticatedSettingsUsageRouteImport } from './routes/_authenticated/settings/usage'
import { Route as AuthenticatedSettingsTelegramRouteImport } from './routes/_authenticated/settings/telegram'
import { Route as AuthenticatedSettingsSupervisionRouteImport } from './routes/_authenticated/settings/supervision'
import { Route as AuthenticatedSettingsStorageRouteImport } from './routes/_authenticated/settings/storage'
import { Route as AuthenticatedSettingsSellerRouteImport } from './routes/_authenticated/settings/seller'
import { Route as AuthenticatedSettingsResourcesRouteImport } from './routes/_authenticated/settings/resources'
import { Route as AuthenticatedSettingsProviderTiersRouteImport } from './routes/_authenticated/settings/provider-tiers'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings/profile'
import { Route as AuthenticatedSettingsPhoneNumbersRouteImport } from './routes/_authenticated/settings/phone-numbers'
import { Route as AuthenticatedSettingsPaymentsRouteImport } from './routes/_authenticated/settings/payments'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsMembersRouteImport } from './routes/_authenticated/settings/members'
import { Route as AuthenticatedSettingsEnvRouteImport } from './routes/_authenticated/settings/env'
import { Route as AuthenticatedSettingsEarningsRouteImport } from './routes/_authenticated/settings/earnings'
import { Route as AuthenticatedSettingsDangerZoneRouteImport } from './routes/_authenticated/settings/danger-zone'
import { Route as AuthenticatedSettingsCredentialsRouteImport } from './routes/_authenticated/settings/credentials'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedSettingsAccessRouteImport } from './routes/_authenticated/settings/access'
import { Route as AuthenticatedProjectProjectIdRouteImport } from './routes/_authenticated/project/$projectId'
import { Route as AuthenticatedMarketTrialsRouteImport } from './routes/_authenticated/market/trials'
import { Route as AuthenticatedMarketSellRouteImport } from './routes/_authenticated/market/sell'
import { Route as AuthenticatedMarketPurchasesRouteImport } from './routes/_authenticated/market/purchases'
import { Route as AuthenticatedMarketModerationRouteImport } from './routes/_authenticated/market/moderation'
import { Route as AuthenticatedMarketLibraryRouteImport } from './routes/_authenticated/market/library'
import { Route as AuthenticatedMarketEngagementsRouteImport } from './routes/_authenticated/market/engagements'
import { Route as AuthenticatedMarketDisputesRouteImport } from './routes/_authenticated/market/disputes'
import { Route as AuthenticatedMarketCheckoutReturnRouteImport } from './routes/_authenticated/market/checkout-return'
import { Route as AuthenticatedMarketCheckoutRouteImport } from './routes/_authenticated/market/checkout'
import { Route as AuthenticatedGoalsGoalIdRouteImport } from './routes/_authenticated/goals/$goalId'
import { Route as AuthenticatedFilesSplatRouteImport } from './routes/_authenticated/files/$'
import { Route as AuthenticatedDepartmentsDeptKeyRouteImport } from './routes/_authenticated/departments/$deptKey'
import { Route as AuthenticatedConstitutionProposalsRouteImport } from './routes/_authenticated/constitution/proposals'
import { Route as AuthenticatedConstitutionEditRouteImport } from './routes/_authenticated/constitution/edit'
import { Route as AuthenticatedCompanyTemplatesRouteImport } from './routes/_authenticated/company/templates'
import { Route as AuthenticatedCompanySkillsRouteImport } from './routes/_authenticated/company/skills'
import { Route as AuthenticatedCompanyRolesRouteImport } from './routes/_authenticated/company/roles'
import { Route as AuthenticatedCompanyPermissionsRouteImport } from './routes/_authenticated/company/permissions'
import { Route as AuthenticatedCompanyOrgChartRouteImport } from './routes/_authenticated/company/org-chart'
import { Route as AuthenticatedCompanyKnowledgeRouteImport } from './routes/_authenticated/company/knowledge'
import { Route as AuthenticatedCompanyConstitutionRouteImport } from './routes/_authenticated/company/constitution'
import { Route as AuthenticatedCompanyConnectorsRouteImport } from './routes/_authenticated/company/connectors'
import { Route as AuthenticatedCompanyApprovalRulesRouteImport } from './routes/_authenticated/company/approval-rules'
import { Route as AuthenticatedCommsUnsortedRouteImport } from './routes/_authenticated/comms/unsorted'
import { Route as AuthenticatedCommsRulesRouteImport } from './routes/_authenticated/comms/rules'
import { Route as AuthenticatedCommsInboxRouteImport } from './routes/_authenticated/comms/inbox'
import { Route as AuthenticatedCommsDraftsRouteImport } from './routes/_authenticated/comms/drafts'
import { Route as AuthenticatedCommsChannelsRouteImport } from './routes/_authenticated/comms/channels'
import { Route as AuthenticatedBrainOrganizeRouteImport } from './routes/_authenticated/brain/organize'
import { Route as AuthenticatedBrainLibraryRouteImport } from './routes/_authenticated/brain/library'
import { Route as AuthenticatedBoardBoardIdRouteImport } from './routes/_authenticated/board/$boardId'
import { Route as AuthenticatedArchitectDispatchRouteImport } from './routes/_authenticated/architect/dispatch'
import { Route as AuthenticatedUniversityTunersIndexRouteImport } from './routes/_authenticated/university/tuners/index'
import { Route as AuthenticatedUniversityTrainingIndexRouteImport } from './routes/_authenticated/university/training/index'
import { Route as AuthenticatedUniversitySkillsIndexRouteImport } from './routes/_authenticated/university/skills/index'
import { Route as AuthenticatedUniversityMarketplaceIndexRouteImport } from './routes/_authenticated/university/marketplace/index'
import { Route as AuthenticatedUniversityAbTestsIndexRouteImport } from './routes/_authenticated/university/ab-tests/index'
import { Route as AuthenticatedBrainLibraryIndexRouteImport } from './routes/_authenticated/brain/library.index'
import { Route as AuthenticatedUniversityTunersTunerIdRouteImport } from './routes/_authenticated/university/tuners/$tunerId'
import { Route as AuthenticatedUniversityTrainingSessionIdRouteImport } from './routes/_authenticated/university/training/$sessionId'
import { Route as AuthenticatedUniversitySkillsSkillIdRouteImport } from './routes/_authenticated/university/skills/$skillId'
import { Route as AuthenticatedUniversityMarketplaceSkillIdRouteImport } from './routes/_authenticated/university/marketplace/$skillId'
import { Route as AuthenticatedUniversityAbTestsNewRouteImport } from './routes/_authenticated/university/ab-tests/new'
import { Route as AuthenticatedUniversityAbTestsTestIdRouteImport } from './routes/_authenticated/university/ab-tests/$testId'
import { Route as AuthenticatedMarketPublishersHandleRouteImport } from './routes/_authenticated/market/publishers.$handle'
import { Route as AuthenticatedMarketPacksPackIdRouteImport } from './routes/_authenticated/market/packs.$packId'
import { Route as AuthenticatedMarketOrdersOrderIdRouteImport } from './routes/_authenticated/market/orders.$orderId'
import { Route as AuthenticatedMarketModerationCaseIdRouteImport } from './routes/_authenticated/market/moderation.$caseId'
import { Route as AuthenticatedMarketExpertsHandleRouteImport } from './routes/_authenticated/market/experts.$handle'
import { Route as AuthenticatedConnectMockRefRouteImport } from './routes/_authenticated/connect.mock.$ref'
import { Route as AuthenticatedCommsTThreadIdRouteImport } from './routes/_authenticated/comms/t.$threadId'
import { Route as AuthenticatedCommsRulesRuleIdRouteImport } from './routes/_authenticated/comms/rules.$ruleId'
import { Route as AuthenticatedCommsChannelsAccountIdRouteImport } from './routes/_authenticated/comms/channels.$accountId'
import { Route as AuthenticatedCheckoutMockRefRouteImport } from './routes/_authenticated/checkout.mock.$ref'
import { Route as AuthenticatedBrainLibrarySourceIdRouteImport } from './routes/_authenticated/brain/library.$sourceId'
import { Route as AuthenticatedBrainEntityEntityIdRouteImport } from './routes/_authenticated/brain/entity/$entityId'
import { Route as AuthenticatedBillingMockPortalRefRouteImport } from './routes/_authenticated/billing.mock-portal.$ref'
import { Route as AuthenticatedArchitectRunRunIdRouteImport } from './routes/_authenticated/architect/run/$runId'
import { Route as AuthenticatedBoardBoardIdCardCardIdRouteImport } from './routes/_authenticated/board/$boardId/card/$cardId'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/signup.lazy').then((d) => d.Route))
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/reset-password.lazy').then((d) => d.Route),
)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/forgot-password.lazy').then((d) => d.Route),
)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWelcomeRoute = AuthenticatedWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/welcome.lazy').then((d) => d.Route),
)
const AuthenticatedSettingsV2Route = AuthenticatedSettingsV2RouteImport.update({
  id: '/settings-v2',
  path: '/settings-v2',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/settings-v2.lazy').then((d) => d.Route),
)
const AuthenticatedMissionRoute = AuthenticatedMissionRouteImport.update({
  id: '/mission',
  path: '/mission',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/mission.lazy').then((d) => d.Route),
)
const AuthenticatedMarketRoute = AuthenticatedMarketRouteImport.update({
  id: '/market',
  path: '/market',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/market.lazy').then((d) => d.Route),
)
const AuthenticatedInboxRoute = AuthenticatedInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/inbox.lazy').then((d) => d.Route),
)
const AuthenticatedFilesRoute = AuthenticatedFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/files.lazy').then((d) => d.Route),
)
const AuthenticatedCommsRoute = AuthenticatedCommsRouteImport.update({
  id: '/comms',
  path: '/comms',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/comms.lazy').then((d) => d.Route),
)
const AuthenticatedBoardsRoute = AuthenticatedBoardsRouteImport.update({
  id: '/boards',
  path: '/boards',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/boards.lazy').then((d) => d.Route),
)
const AuthenticatedUniversityIndexRoute =
  AuthenticatedUniversityIndexRouteImport.update({
    id: '/university/',
    path: '/university/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/university/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedStrategyIndexRoute =
  AuthenticatedStrategyIndexRouteImport.update({
    id: '/strategy/',
    path: '/strategy/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/strategy/index.lazy').then((d) => d.Route),
  )
const AuthenticatedPrinciplesIndexRoute =
  AuthenticatedPrinciplesIndexRouteImport.update({
    id: '/principles/',
    path: '/principles/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/principles/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMarketIndexRoute =
  AuthenticatedMarketIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMarketRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/market/index.lazy').then((d) => d.Route),
  )
const AuthenticatedGoalsIndexRoute = AuthenticatedGoalsIndexRouteImport.update({
  id: '/goals/',
  path: '/goals/',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/goals/index.lazy').then((d) => d.Route),
)
const AuthenticatedDepartmentsIndexRoute =
  AuthenticatedDepartmentsIndexRouteImport.update({
    id: '/departments/',
    path: '/departments/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/departments/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/dashboard/index.lazy').then((d) => d.Route),
  )
const AuthenticatedConstitutionIndexRoute =
  AuthenticatedConstitutionIndexRouteImport.update({
    id: '/constitution/',
    path: '/constitution/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/constitution/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompanyIndexRoute =
  AuthenticatedCompanyIndexRouteImport.update({
    id: '/company/',
    path: '/company/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/company/index.lazy').then((d) => d.Route),
  )
const AuthenticatedCommsIndexRoute = AuthenticatedCommsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedCommsRoute,
} as any)
const AuthenticatedBrainIndexRoute = AuthenticatedBrainIndexRouteImport.update({
  id: '/brain/',
  path: '/brain/',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/brain/index.lazy').then((d) => d.Route),
)
const AuthenticatedArchitectIndexRoute =
  AuthenticatedArchitectIndexRouteImport.update({
    id: '/architect/',
    path: '/architect/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/architect/index.lazy').then((d) => d.Route),
  )
const AuthenticatedUniversityPatternsRoute =
  AuthenticatedUniversityPatternsRouteImport.update({
    id: '/university/patterns',
    path: '/university/patterns',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/university/patterns.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsWorkspaceRoute =
  AuthenticatedSettingsWorkspaceRouteImport.update({
    id: '/settings/workspace',
    path: '/settings/workspace',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/workspace.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsUsersRoute =
  AuthenticatedSettingsUsersRouteImport.update({
    id: '/settings/users',
    path: '/settings/users',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/users.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsUsageRoute =
  AuthenticatedSettingsUsageRouteImport.update({
    id: '/settings/usage',
    path: '/settings/usage',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/usage.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsTelegramRoute =
  AuthenticatedSettingsTelegramRouteImport.update({
    id: '/settings/telegram',
    path: '/settings/telegram',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/telegram.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsSupervisionRoute =
  AuthenticatedSettingsSupervisionRouteImport.update({
    id: '/settings/supervision',
    path: '/settings/supervision',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/supervision.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsStorageRoute =
  AuthenticatedSettingsStorageRouteImport.update({
    id: '/settings/storage',
    path: '/settings/storage',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/storage.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsSellerRoute =
  AuthenticatedSettingsSellerRouteImport.update({
    id: '/settings/seller',
    path: '/settings/seller',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/seller.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsResourcesRoute =
  AuthenticatedSettingsResourcesRouteImport.update({
    id: '/settings/resources',
    path: '/settings/resources',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/resources.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsProviderTiersRoute =
  AuthenticatedSettingsProviderTiersRouteImport.update({
    id: '/settings/provider-tiers',
    path: '/settings/provider-tiers',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/provider-tiers.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/settings/profile',
    path: '/settings/profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/profile.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsPhoneNumbersRoute =
  AuthenticatedSettingsPhoneNumbersRouteImport.update({
    id: '/settings/phone-numbers',
    path: '/settings/phone-numbers',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/phone-numbers.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsPaymentsRoute =
  AuthenticatedSettingsPaymentsRouteImport.update({
    id: '/settings/payments',
    path: '/settings/payments',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/payments.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/notifications.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsMembersRoute =
  AuthenticatedSettingsMembersRouteImport.update({
    id: '/settings/members',
    path: '/settings/members',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/members.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsEnvRoute =
  AuthenticatedSettingsEnvRouteImport.update({
    id: '/settings/env',
    path: '/settings/env',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/env.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsEarningsRoute =
  AuthenticatedSettingsEarningsRouteImport.update({
    id: '/settings/earnings',
    path: '/settings/earnings',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/earnings.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsDangerZoneRoute =
  AuthenticatedSettingsDangerZoneRouteImport.update({
    id: '/settings/danger-zone',
    path: '/settings/danger-zone',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/danger-zone.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCredentialsRoute =
  AuthenticatedSettingsCredentialsRouteImport.update({
    id: '/settings/credentials',
    path: '/settings/credentials',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/credentials.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/settings/account',
    path: '/settings/account',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/account.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAccessRoute =
  AuthenticatedSettingsAccessRouteImport.update({
    id: '/settings/access',
    path: '/settings/access',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/access.lazy').then((d) => d.Route),
  )
const AuthenticatedProjectProjectIdRoute =
  AuthenticatedProjectProjectIdRouteImport.update({
    id: '/project/$projectId',
    path: '/project/$projectId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/project/$projectId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMarketTrialsRoute =
  AuthenticatedMarketTrialsRouteImport.update({
    id: '/trials',
    path: '/trials',
    getParentRoute: () => AuthenticatedMarketRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/market/trials.lazy').then((d) => d.Route),
  )
const AuthenticatedMarketSellRoute = AuthenticatedMarketSellRouteImport.update({
  id: '/sell',
  path: '/sell',
  getParentRoute: () => AuthenticatedMarketRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/market/sell.lazy').then((d) => d.Route),
)
const AuthenticatedMarketPurchasesRoute =
  AuthenticatedMarketPurchasesRouteImport.update({
    id: '/purchases',
    path: '/purchases',
    getParentRoute: () => AuthenticatedMarketRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/market/purchases.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMarketModerationRoute =
  AuthenticatedMarketModerationRouteImport.update({
    id: '/moderation',
    path: '/moderation',
    getParentRoute: () => AuthenticatedMarketRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/market/moderation.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMarketLibraryRoute =
  AuthenticatedMarketLibraryRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => AuthenticatedMarketRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/market/library.lazy').then((d) => d.Route),
  )
const AuthenticatedMarketEngagementsRoute =
  AuthenticatedMarketEngagementsRouteImport.update({
    id: '/engagements',
    path: '/engagements',
    getParentRoute: () => AuthenticatedMarketRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/market/engagements.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMarketDisputesRoute =
  AuthenticatedMarketDisputesRouteImport.update({
    id: '/disputes',
    path: '/disputes',
    getParentRoute: () => AuthenticatedMarketRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/market/disputes.lazy').then((d) => d.Route),
  )
const AuthenticatedMarketCheckoutReturnRoute =
  AuthenticatedMarketCheckoutReturnRouteImport.update({
    id: '/checkout-return',
    path: '/checkout-return',
    getParentRoute: () => AuthenticatedMarketRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/market/checkout-return.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMarketCheckoutRoute =
  AuthenticatedMarketCheckoutRouteImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => AuthenticatedMarketRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/market/checkout.lazy').then((d) => d.Route),
  )
const AuthenticatedGoalsGoalIdRoute =
  AuthenticatedGoalsGoalIdRouteImport.update({
    id: '/goals/$goalId',
    path: '/goals/$goalId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/goals/$goalId.lazy').then((d) => d.Route),
  )
const AuthenticatedFilesSplatRoute = AuthenticatedFilesSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedFilesRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/files/$.lazy').then((d) => d.Route),
)
const AuthenticatedDepartmentsDeptKeyRoute =
  AuthenticatedDepartmentsDeptKeyRouteImport.update({
    id: '/departments/$deptKey',
    path: '/departments/$deptKey',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/departments/$deptKey.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedConstitutionProposalsRoute =
  AuthenticatedConstitutionProposalsRouteImport.update({
    id: '/constitution/proposals',
    path: '/constitution/proposals',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/constitution/proposals.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedConstitutionEditRoute =
  AuthenticatedConstitutionEditRouteImport.update({
    id: '/constitution/edit',
    path: '/constitution/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/constitution/edit.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompanyTemplatesRoute =
  AuthenticatedCompanyTemplatesRouteImport.update({
    id: '/company/templates',
    path: '/company/templates',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/company/templates.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompanySkillsRoute =
  AuthenticatedCompanySkillsRouteImport.update({
    id: '/company/skills',
    path: '/company/skills',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/company/skills.lazy').then((d) => d.Route),
  )
const AuthenticatedCompanyRolesRoute =
  AuthenticatedCompanyRolesRouteImport.update({
    id: '/company/roles',
    path: '/company/roles',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/company/roles.lazy').then((d) => d.Route),
  )
const AuthenticatedCompanyPermissionsRoute =
  AuthenticatedCompanyPermissionsRouteImport.update({
    id: '/company/permissions',
    path: '/company/permissions',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/company/permissions.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompanyOrgChartRoute =
  AuthenticatedCompanyOrgChartRouteImport.update({
    id: '/company/org-chart',
    path: '/company/org-chart',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/company/org-chart.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompanyKnowledgeRoute =
  AuthenticatedCompanyKnowledgeRouteImport.update({
    id: '/company/knowledge',
    path: '/company/knowledge',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/company/knowledge.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompanyConstitutionRoute =
  AuthenticatedCompanyConstitutionRouteImport.update({
    id: '/company/constitution',
    path: '/company/constitution',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/company/constitution.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompanyConnectorsRoute =
  AuthenticatedCompanyConnectorsRouteImport.update({
    id: '/company/connectors',
    path: '/company/connectors',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/company/connectors.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompanyApprovalRulesRoute =
  AuthenticatedCompanyApprovalRulesRouteImport.update({
    id: '/company/approval-rules',
    path: '/company/approval-rules',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/company/approval-rules.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCommsUnsortedRoute =
  AuthenticatedCommsUnsortedRouteImport.update({
    id: '/unsorted',
    path: '/unsorted',
    getParentRoute: () => AuthenticatedCommsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/comms/unsorted.lazy').then((d) => d.Route),
  )
const AuthenticatedCommsRulesRoute = AuthenticatedCommsRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => AuthenticatedCommsRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/comms/rules.lazy').then((d) => d.Route),
)
const AuthenticatedCommsInboxRoute = AuthenticatedCommsInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthenticatedCommsRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/comms/inbox.lazy').then((d) => d.Route),
)
const AuthenticatedCommsDraftsRoute =
  AuthenticatedCommsDraftsRouteImport.update({
    id: '/drafts',
    path: '/drafts',
    getParentRoute: () => AuthenticatedCommsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/comms/drafts.lazy').then((d) => d.Route),
  )
const AuthenticatedCommsChannelsRoute =
  AuthenticatedCommsChannelsRouteImport.update({
    id: '/channels',
    path: '/channels',
    getParentRoute: () => AuthenticatedCommsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/comms/channels.lazy').then((d) => d.Route),
  )
const AuthenticatedBrainOrganizeRoute =
  AuthenticatedBrainOrganizeRouteImport.update({
    id: '/brain/organize',
    path: '/brain/organize',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/brain/organize.lazy').then((d) => d.Route),
  )
const AuthenticatedBrainLibraryRoute =
  AuthenticatedBrainLibraryRouteImport.update({
    id: '/brain/library',
    path: '/brain/library',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/brain/library.lazy').then((d) => d.Route),
  )
const AuthenticatedBoardBoardIdRoute =
  AuthenticatedBoardBoardIdRouteImport.update({
    id: '/board/$boardId',
    path: '/board/$boardId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/board/$boardId.lazy').then((d) => d.Route),
  )
const AuthenticatedArchitectDispatchRoute =
  AuthenticatedArchitectDispatchRouteImport.update({
    id: '/architect/dispatch',
    path: '/architect/dispatch',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/architect/dispatch.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedUniversityTunersIndexRoute =
  AuthenticatedUniversityTunersIndexRouteImport.update({
    id: '/university/tuners/',
    path: '/university/tuners/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/university/tuners/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedUniversityTrainingIndexRoute =
  AuthenticatedUniversityTrainingIndexRouteImport.update({
    id: '/university/training/',
    path: '/university/training/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/university/training/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedUniversitySkillsIndexRoute =
  AuthenticatedUniversitySkillsIndexRouteImport.update({
    id: '/university/skills/',
    path: '/university/skills/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/university/skills/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedUniversityMarketplaceIndexRoute =
  AuthenticatedUniversityMarketplaceIndexRouteImport.update({
    id: '/university/marketplace/',
    path: '/university/marketplace/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/university/marketplace/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedUniversityAbTestsIndexRoute =
  AuthenticatedUniversityAbTestsIndexRouteImport.update({
    id: '/university/ab-tests/',
    path: '/university/ab-tests/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/university/ab-tests/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedBrainLibraryIndexRoute =
  AuthenticatedBrainLibraryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBrainLibraryRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/brain/library.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedUniversityTunersTunerIdRoute =
  AuthenticatedUniversityTunersTunerIdRouteImport.update({
    id: '/university/tuners/$tunerId',
    path: '/university/tuners/$tunerId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/university/tuners/$tunerId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedUniversityTrainingSessionIdRoute =
  AuthenticatedUniversityTrainingSessionIdRouteImport.update({
    id: '/university/training/$sessionId',
    path: '/university/training/$sessionId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/university/training/$sessionId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedUniversitySkillsSkillIdRoute =
  AuthenticatedUniversitySkillsSkillIdRouteImport.update({
    id: '/university/skills/$skillId',
    path: '/university/skills/$skillId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/university/skills/$skillId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedUniversityMarketplaceSkillIdRoute =
  AuthenticatedUniversityMarketplaceSkillIdRouteImport.update({
    id: '/university/marketplace/$skillId',
    path: '/university/marketplace/$skillId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/university/marketplace/$skillId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedUniversityAbTestsNewRoute =
  AuthenticatedUniversityAbTestsNewRouteImport.update({
    id: '/university/ab-tests/new',
    path: '/university/ab-tests/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/university/ab-tests/new.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedUniversityAbTestsTestIdRoute =
  AuthenticatedUniversityAbTestsTestIdRouteImport.update({
    id: '/university/ab-tests/$testId',
    path: '/university/ab-tests/$testId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/university/ab-tests/$testId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMarketPublishersHandleRoute =
  AuthenticatedMarketPublishersHandleRouteImport.update({
    id: '/publishers/$handle',
    path: '/publishers/$handle',
    getParentRoute: () => AuthenticatedMarketRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/market/publishers.$handle.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMarketPacksPackIdRoute =
  AuthenticatedMarketPacksPackIdRouteImport.update({
    id: '/packs/$packId',
    path: '/packs/$packId',
    getParentRoute: () => AuthenticatedMarketRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/market/packs.$packId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMarketOrdersOrderIdRoute =
  AuthenticatedMarketOrdersOrderIdRouteImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => AuthenticatedMarketRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/market/orders.$orderId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMarketModerationCaseIdRoute =
  AuthenticatedMarketModerationCaseIdRouteImport.update({
    id: '/$caseId',
    path: '/$caseId',
    getParentRoute: () => AuthenticatedMarketModerationRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/market/moderation.$caseId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMarketExpertsHandleRoute =
  AuthenticatedMarketExpertsHandleRouteImport.update({
    id: '/experts/$handle',
    path: '/experts/$handle',
    getParentRoute: () => AuthenticatedMarketRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/market/experts.$handle.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedConnectMockRefRoute =
  AuthenticatedConnectMockRefRouteImport.update({
    id: '/connect/mock/$ref',
    path: '/connect/mock/$ref',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/connect.mock.$ref.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCommsTThreadIdRoute =
  AuthenticatedCommsTThreadIdRouteImport.update({
    id: '/t/$threadId',
    path: '/t/$threadId',
    getParentRoute: () => AuthenticatedCommsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/comms/t.$threadId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCommsRulesRuleIdRoute =
  AuthenticatedCommsRulesRuleIdRouteImport.update({
    id: '/$ruleId',
    path: '/$ruleId',
    getParentRoute: () => AuthenticatedCommsRulesRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/comms/rules.$ruleId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCommsChannelsAccountIdRoute =
  AuthenticatedCommsChannelsAccountIdRouteImport.update({
    id: '/$accountId',
    path: '/$accountId',
    getParentRoute: () => AuthenticatedCommsChannelsRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/comms/channels.$accountId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCheckoutMockRefRoute =
  AuthenticatedCheckoutMockRefRouteImport.update({
    id: '/checkout/mock/$ref',
    path: '/checkout/mock/$ref',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/checkout.mock.$ref.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedBrainLibrarySourceIdRoute =
  AuthenticatedBrainLibrarySourceIdRouteImport.update({
    id: '/$sourceId',
    path: '/$sourceId',
    getParentRoute: () => AuthenticatedBrainLibraryRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/brain/library.$sourceId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedBrainEntityEntityIdRoute =
  AuthenticatedBrainEntityEntityIdRouteImport.update({
    id: '/brain/entity/$entityId',
    path: '/brain/entity/$entityId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/brain/entity/$entityId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedBillingMockPortalRefRoute =
  AuthenticatedBillingMockPortalRefRouteImport.update({
    id: '/billing/mock-portal/$ref',
    path: '/billing/mock-portal/$ref',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/billing.mock-portal.$ref.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedArchitectRunRunIdRoute =
  AuthenticatedArchitectRunRunIdRouteImport.update({
    id: '/architect/run/$runId',
    path: '/architect/run/$runId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/architect/run/$runId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedBoardBoardIdCardCardIdRoute =
  AuthenticatedBoardBoardIdCardCardIdRouteImport.update({
    id: '/card/$cardId',
    path: '/card/$cardId',
    getParentRoute: () => AuthenticatedBoardBoardIdRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/board/$boardId/card/$cardId.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/boards': typeof AuthenticatedBoardsRoute
  '/comms': typeof AuthenticatedCommsRouteWithChildren
  '/files': typeof AuthenticatedFilesRouteWithChildren
  '/inbox': typeof AuthenticatedInboxRoute
  '/market': typeof AuthenticatedMarketRouteWithChildren
  '/mission': typeof AuthenticatedMissionRoute
  '/settings-v2': typeof AuthenticatedSettingsV2Route
  '/welcome': typeof AuthenticatedWelcomeRoute
  '/architect/dispatch': typeof AuthenticatedArchitectDispatchRoute
  '/board/$boardId': typeof AuthenticatedBoardBoardIdRouteWithChildren
  '/brain/library': typeof AuthenticatedBrainLibraryRouteWithChildren
  '/brain/organize': typeof AuthenticatedBrainOrganizeRoute
  '/comms/channels': typeof AuthenticatedCommsChannelsRouteWithChildren
  '/comms/drafts': typeof AuthenticatedCommsDraftsRoute
  '/comms/inbox': typeof AuthenticatedCommsInboxRoute
  '/comms/rules': typeof AuthenticatedCommsRulesRouteWithChildren
  '/comms/unsorted': typeof AuthenticatedCommsUnsortedRoute
  '/company/approval-rules': typeof AuthenticatedCompanyApprovalRulesRoute
  '/company/connectors': typeof AuthenticatedCompanyConnectorsRoute
  '/company/constitution': typeof AuthenticatedCompanyConstitutionRoute
  '/company/knowledge': typeof AuthenticatedCompanyKnowledgeRoute
  '/company/org-chart': typeof AuthenticatedCompanyOrgChartRoute
  '/company/permissions': typeof AuthenticatedCompanyPermissionsRoute
  '/company/roles': typeof AuthenticatedCompanyRolesRoute
  '/company/skills': typeof AuthenticatedCompanySkillsRoute
  '/company/templates': typeof AuthenticatedCompanyTemplatesRoute
  '/constitution/edit': typeof AuthenticatedConstitutionEditRoute
  '/constitution/proposals': typeof AuthenticatedConstitutionProposalsRoute
  '/departments/$deptKey': typeof AuthenticatedDepartmentsDeptKeyRoute
  '/files/$': typeof AuthenticatedFilesSplatRoute
  '/goals/$goalId': typeof AuthenticatedGoalsGoalIdRoute
  '/market/checkout': typeof AuthenticatedMarketCheckoutRoute
  '/market/checkout-return': typeof AuthenticatedMarketCheckoutReturnRoute
  '/market/disputes': typeof AuthenticatedMarketDisputesRoute
  '/market/engagements': typeof AuthenticatedMarketEngagementsRoute
  '/market/library': typeof AuthenticatedMarketLibraryRoute
  '/market/moderation': typeof AuthenticatedMarketModerationRouteWithChildren
  '/market/purchases': typeof AuthenticatedMarketPurchasesRoute
  '/market/sell': typeof AuthenticatedMarketSellRoute
  '/market/trials': typeof AuthenticatedMarketTrialsRoute
  '/project/$projectId': typeof AuthenticatedProjectProjectIdRoute
  '/settings/access': typeof AuthenticatedSettingsAccessRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/credentials': typeof AuthenticatedSettingsCredentialsRoute
  '/settings/danger-zone': typeof AuthenticatedSettingsDangerZoneRoute
  '/settings/earnings': typeof AuthenticatedSettingsEarningsRoute
  '/settings/env': typeof AuthenticatedSettingsEnvRoute
  '/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/payments': typeof AuthenticatedSettingsPaymentsRoute
  '/settings/phone-numbers': typeof AuthenticatedSettingsPhoneNumbersRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/provider-tiers': typeof AuthenticatedSettingsProviderTiersRoute
  '/settings/resources': typeof AuthenticatedSettingsResourcesRoute
  '/settings/seller': typeof AuthenticatedSettingsSellerRoute
  '/settings/storage': typeof AuthenticatedSettingsStorageRoute
  '/settings/supervision': typeof AuthenticatedSettingsSupervisionRoute
  '/settings/telegram': typeof AuthenticatedSettingsTelegramRoute
  '/settings/usage': typeof AuthenticatedSettingsUsageRoute
  '/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/settings/workspace': typeof AuthenticatedSettingsWorkspaceRoute
  '/university/patterns': typeof AuthenticatedUniversityPatternsRoute
  '/architect/': typeof AuthenticatedArchitectIndexRoute
  '/brain/': typeof AuthenticatedBrainIndexRoute
  '/comms/': typeof AuthenticatedCommsIndexRoute
  '/company/': typeof AuthenticatedCompanyIndexRoute
  '/constitution/': typeof AuthenticatedConstitutionIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/departments/': typeof AuthenticatedDepartmentsIndexRoute
  '/goals/': typeof AuthenticatedGoalsIndexRoute
  '/market/': typeof AuthenticatedMarketIndexRoute
  '/principles/': typeof AuthenticatedPrinciplesIndexRoute
  '/strategy/': typeof AuthenticatedStrategyIndexRoute
  '/university/': typeof AuthenticatedUniversityIndexRoute
  '/architect/run/$runId': typeof AuthenticatedArchitectRunRunIdRoute
  '/billing/mock-portal/$ref': typeof AuthenticatedBillingMockPortalRefRoute
  '/brain/entity/$entityId': typeof AuthenticatedBrainEntityEntityIdRoute
  '/brain/library/$sourceId': typeof AuthenticatedBrainLibrarySourceIdRoute
  '/checkout/mock/$ref': typeof AuthenticatedCheckoutMockRefRoute
  '/comms/channels/$accountId': typeof AuthenticatedCommsChannelsAccountIdRoute
  '/comms/rules/$ruleId': typeof AuthenticatedCommsRulesRuleIdRoute
  '/comms/t/$threadId': typeof AuthenticatedCommsTThreadIdRoute
  '/connect/mock/$ref': typeof AuthenticatedConnectMockRefRoute
  '/market/experts/$handle': typeof AuthenticatedMarketExpertsHandleRoute
  '/market/moderation/$caseId': typeof AuthenticatedMarketModerationCaseIdRoute
  '/market/orders/$orderId': typeof AuthenticatedMarketOrdersOrderIdRoute
  '/market/packs/$packId': typeof AuthenticatedMarketPacksPackIdRoute
  '/market/publishers/$handle': typeof AuthenticatedMarketPublishersHandleRoute
  '/university/ab-tests/$testId': typeof AuthenticatedUniversityAbTestsTestIdRoute
  '/university/ab-tests/new': typeof AuthenticatedUniversityAbTestsNewRoute
  '/university/marketplace/$skillId': typeof AuthenticatedUniversityMarketplaceSkillIdRoute
  '/university/skills/$skillId': typeof AuthenticatedUniversitySkillsSkillIdRoute
  '/university/training/$sessionId': typeof AuthenticatedUniversityTrainingSessionIdRoute
  '/university/tuners/$tunerId': typeof AuthenticatedUniversityTunersTunerIdRoute
  '/brain/library/': typeof AuthenticatedBrainLibraryIndexRoute
  '/university/ab-tests/': typeof AuthenticatedUniversityAbTestsIndexRoute
  '/university/marketplace/': typeof AuthenticatedUniversityMarketplaceIndexRoute
  '/university/skills/': typeof AuthenticatedUniversitySkillsIndexRoute
  '/university/training/': typeof AuthenticatedUniversityTrainingIndexRoute
  '/university/tuners/': typeof AuthenticatedUniversityTunersIndexRoute
  '/board/$boardId/card/$cardId': typeof AuthenticatedBoardBoardIdCardCardIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/boards': typeof AuthenticatedBoardsRoute
  '/files': typeof AuthenticatedFilesRouteWithChildren
  '/inbox': typeof AuthenticatedInboxRoute
  '/mission': typeof AuthenticatedMissionRoute
  '/settings-v2': typeof AuthenticatedSettingsV2Route
  '/welcome': typeof AuthenticatedWelcomeRoute
  '/architect/dispatch': typeof AuthenticatedArchitectDispatchRoute
  '/board/$boardId': typeof AuthenticatedBoardBoardIdRouteWithChildren
  '/brain/organize': typeof AuthenticatedBrainOrganizeRoute
  '/comms/channels': typeof AuthenticatedCommsChannelsRouteWithChildren
  '/comms/drafts': typeof AuthenticatedCommsDraftsRoute
  '/comms/inbox': typeof AuthenticatedCommsInboxRoute
  '/comms/rules': typeof AuthenticatedCommsRulesRouteWithChildren
  '/comms/unsorted': typeof AuthenticatedCommsUnsortedRoute
  '/company/approval-rules': typeof AuthenticatedCompanyApprovalRulesRoute
  '/company/connectors': typeof AuthenticatedCompanyConnectorsRoute
  '/company/constitution': typeof AuthenticatedCompanyConstitutionRoute
  '/company/knowledge': typeof AuthenticatedCompanyKnowledgeRoute
  '/company/org-chart': typeof AuthenticatedCompanyOrgChartRoute
  '/company/permissions': typeof AuthenticatedCompanyPermissionsRoute
  '/company/roles': typeof AuthenticatedCompanyRolesRoute
  '/company/skills': typeof AuthenticatedCompanySkillsRoute
  '/company/templates': typeof AuthenticatedCompanyTemplatesRoute
  '/constitution/edit': typeof AuthenticatedConstitutionEditRoute
  '/constitution/proposals': typeof AuthenticatedConstitutionProposalsRoute
  '/departments/$deptKey': typeof AuthenticatedDepartmentsDeptKeyRoute
  '/files/$': typeof AuthenticatedFilesSplatRoute
  '/goals/$goalId': typeof AuthenticatedGoalsGoalIdRoute
  '/market/checkout': typeof AuthenticatedMarketCheckoutRoute
  '/market/checkout-return': typeof AuthenticatedMarketCheckoutReturnRoute
  '/market/disputes': typeof AuthenticatedMarketDisputesRoute
  '/market/engagements': typeof AuthenticatedMarketEngagementsRoute
  '/market/library': typeof AuthenticatedMarketLibraryRoute
  '/market/moderation': typeof AuthenticatedMarketModerationRouteWithChildren
  '/market/purchases': typeof AuthenticatedMarketPurchasesRoute
  '/market/sell': typeof AuthenticatedMarketSellRoute
  '/market/trials': typeof AuthenticatedMarketTrialsRoute
  '/project/$projectId': typeof AuthenticatedProjectProjectIdRoute
  '/settings/access': typeof AuthenticatedSettingsAccessRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/credentials': typeof AuthenticatedSettingsCredentialsRoute
  '/settings/danger-zone': typeof AuthenticatedSettingsDangerZoneRoute
  '/settings/earnings': typeof AuthenticatedSettingsEarningsRoute
  '/settings/env': typeof AuthenticatedSettingsEnvRoute
  '/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/payments': typeof AuthenticatedSettingsPaymentsRoute
  '/settings/phone-numbers': typeof AuthenticatedSettingsPhoneNumbersRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/provider-tiers': typeof AuthenticatedSettingsProviderTiersRoute
  '/settings/resources': typeof AuthenticatedSettingsResourcesRoute
  '/settings/seller': typeof AuthenticatedSettingsSellerRoute
  '/settings/storage': typeof AuthenticatedSettingsStorageRoute
  '/settings/supervision': typeof AuthenticatedSettingsSupervisionRoute
  '/settings/telegram': typeof AuthenticatedSettingsTelegramRoute
  '/settings/usage': typeof AuthenticatedSettingsUsageRoute
  '/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/settings/workspace': typeof AuthenticatedSettingsWorkspaceRoute
  '/university/patterns': typeof AuthenticatedUniversityPatternsRoute
  '/architect': typeof AuthenticatedArchitectIndexRoute
  '/brain': typeof AuthenticatedBrainIndexRoute
  '/comms': typeof AuthenticatedCommsIndexRoute
  '/company': typeof AuthenticatedCompanyIndexRoute
  '/constitution': typeof AuthenticatedConstitutionIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/departments': typeof AuthenticatedDepartmentsIndexRoute
  '/goals': typeof AuthenticatedGoalsIndexRoute
  '/market': typeof AuthenticatedMarketIndexRoute
  '/principles': typeof AuthenticatedPrinciplesIndexRoute
  '/strategy': typeof AuthenticatedStrategyIndexRoute
  '/university': typeof AuthenticatedUniversityIndexRoute
  '/architect/run/$runId': typeof AuthenticatedArchitectRunRunIdRoute
  '/billing/mock-portal/$ref': typeof AuthenticatedBillingMockPortalRefRoute
  '/brain/entity/$entityId': typeof AuthenticatedBrainEntityEntityIdRoute
  '/brain/library/$sourceId': typeof AuthenticatedBrainLibrarySourceIdRoute
  '/checkout/mock/$ref': typeof AuthenticatedCheckoutMockRefRoute
  '/comms/channels/$accountId': typeof AuthenticatedCommsChannelsAccountIdRoute
  '/comms/rules/$ruleId': typeof AuthenticatedCommsRulesRuleIdRoute
  '/comms/t/$threadId': typeof AuthenticatedCommsTThreadIdRoute
  '/connect/mock/$ref': typeof AuthenticatedConnectMockRefRoute
  '/market/experts/$handle': typeof AuthenticatedMarketExpertsHandleRoute
  '/market/moderation/$caseId': typeof AuthenticatedMarketModerationCaseIdRoute
  '/market/orders/$orderId': typeof AuthenticatedMarketOrdersOrderIdRoute
  '/market/packs/$packId': typeof AuthenticatedMarketPacksPackIdRoute
  '/market/publishers/$handle': typeof AuthenticatedMarketPublishersHandleRoute
  '/university/ab-tests/$testId': typeof AuthenticatedUniversityAbTestsTestIdRoute
  '/university/ab-tests/new': typeof AuthenticatedUniversityAbTestsNewRoute
  '/university/marketplace/$skillId': typeof AuthenticatedUniversityMarketplaceSkillIdRoute
  '/university/skills/$skillId': typeof AuthenticatedUniversitySkillsSkillIdRoute
  '/university/training/$sessionId': typeof AuthenticatedUniversityTrainingSessionIdRoute
  '/university/tuners/$tunerId': typeof AuthenticatedUniversityTunersTunerIdRoute
  '/brain/library': typeof AuthenticatedBrainLibraryIndexRoute
  '/university/ab-tests': typeof AuthenticatedUniversityAbTestsIndexRoute
  '/university/marketplace': typeof AuthenticatedUniversityMarketplaceIndexRoute
  '/university/skills': typeof AuthenticatedUniversitySkillsIndexRoute
  '/university/training': typeof AuthenticatedUniversityTrainingIndexRoute
  '/university/tuners': typeof AuthenticatedUniversityTunersIndexRoute
  '/board/$boardId/card/$cardId': typeof AuthenticatedBoardBoardIdCardCardIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/_authenticated/boards': typeof AuthenticatedBoardsRoute
  '/_authenticated/comms': typeof AuthenticatedCommsRouteWithChildren
  '/_authenticated/files': typeof AuthenticatedFilesRouteWithChildren
  '/_authenticated/inbox': typeof AuthenticatedInboxRoute
  '/_authenticated/market': typeof AuthenticatedMarketRouteWithChildren
  '/_authenticated/mission': typeof AuthenticatedMissionRoute
  '/_authenticated/settings-v2': typeof AuthenticatedSettingsV2Route
  '/_authenticated/welcome': typeof AuthenticatedWelcomeRoute
  '/_authenticated/architect/dispatch': typeof AuthenticatedArchitectDispatchRoute
  '/_authenticated/board/$boardId': typeof AuthenticatedBoardBoardIdRouteWithChildren
  '/_authenticated/brain/library': typeof AuthenticatedBrainLibraryRouteWithChildren
  '/_authenticated/brain/organize': typeof AuthenticatedBrainOrganizeRoute
  '/_authenticated/comms/channels': typeof AuthenticatedCommsChannelsRouteWithChildren
  '/_authenticated/comms/drafts': typeof AuthenticatedCommsDraftsRoute
  '/_authenticated/comms/inbox': typeof AuthenticatedCommsInboxRoute
  '/_authenticated/comms/rules': typeof AuthenticatedCommsRulesRouteWithChildren
  '/_authenticated/comms/unsorted': typeof AuthenticatedCommsUnsortedRoute
  '/_authenticated/company/approval-rules': typeof AuthenticatedCompanyApprovalRulesRoute
  '/_authenticated/company/connectors': typeof AuthenticatedCompanyConnectorsRoute
  '/_authenticated/company/constitution': typeof AuthenticatedCompanyConstitutionRoute
  '/_authenticated/company/knowledge': typeof AuthenticatedCompanyKnowledgeRoute
  '/_authenticated/company/org-chart': typeof AuthenticatedCompanyOrgChartRoute
  '/_authenticated/company/permissions': typeof AuthenticatedCompanyPermissionsRoute
  '/_authenticated/company/roles': typeof AuthenticatedCompanyRolesRoute
  '/_authenticated/company/skills': typeof AuthenticatedCompanySkillsRoute
  '/_authenticated/company/templates': typeof AuthenticatedCompanyTemplatesRoute
  '/_authenticated/constitution/edit': typeof AuthenticatedConstitutionEditRoute
  '/_authenticated/constitution/proposals': typeof AuthenticatedConstitutionProposalsRoute
  '/_authenticated/departments/$deptKey': typeof AuthenticatedDepartmentsDeptKeyRoute
  '/_authenticated/files/$': typeof AuthenticatedFilesSplatRoute
  '/_authenticated/goals/$goalId': typeof AuthenticatedGoalsGoalIdRoute
  '/_authenticated/market/checkout': typeof AuthenticatedMarketCheckoutRoute
  '/_authenticated/market/checkout-return': typeof AuthenticatedMarketCheckoutReturnRoute
  '/_authenticated/market/disputes': typeof AuthenticatedMarketDisputesRoute
  '/_authenticated/market/engagements': typeof AuthenticatedMarketEngagementsRoute
  '/_authenticated/market/library': typeof AuthenticatedMarketLibraryRoute
  '/_authenticated/market/moderation': typeof AuthenticatedMarketModerationRouteWithChildren
  '/_authenticated/market/purchases': typeof AuthenticatedMarketPurchasesRoute
  '/_authenticated/market/sell': typeof AuthenticatedMarketSellRoute
  '/_authenticated/market/trials': typeof AuthenticatedMarketTrialsRoute
  '/_authenticated/project/$projectId': typeof AuthenticatedProjectProjectIdRoute
  '/_authenticated/settings/access': typeof AuthenticatedSettingsAccessRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/credentials': typeof AuthenticatedSettingsCredentialsRoute
  '/_authenticated/settings/danger-zone': typeof AuthenticatedSettingsDangerZoneRoute
  '/_authenticated/settings/earnings': typeof AuthenticatedSettingsEarningsRoute
  '/_authenticated/settings/env': typeof AuthenticatedSettingsEnvRoute
  '/_authenticated/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/settings/payments': typeof AuthenticatedSettingsPaymentsRoute
  '/_authenticated/settings/phone-numbers': typeof AuthenticatedSettingsPhoneNumbersRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_authenticated/settings/provider-tiers': typeof AuthenticatedSettingsProviderTiersRoute
  '/_authenticated/settings/resources': typeof AuthenticatedSettingsResourcesRoute
  '/_authenticated/settings/seller': typeof AuthenticatedSettingsSellerRoute
  '/_authenticated/settings/storage': typeof AuthenticatedSettingsStorageRoute
  '/_authenticated/settings/supervision': typeof AuthenticatedSettingsSupervisionRoute
  '/_authenticated/settings/telegram': typeof AuthenticatedSettingsTelegramRoute
  '/_authenticated/settings/usage': typeof AuthenticatedSettingsUsageRoute
  '/_authenticated/settings/users': typeof AuthenticatedSettingsUsersRoute
  '/_authenticated/settings/workspace': typeof AuthenticatedSettingsWorkspaceRoute
  '/_authenticated/university/patterns': typeof AuthenticatedUniversityPatternsRoute
  '/_authenticated/architect/': typeof AuthenticatedArchitectIndexRoute
  '/_authenticated/brain/': typeof AuthenticatedBrainIndexRoute
  '/_authenticated/comms/': typeof AuthenticatedCommsIndexRoute
  '/_authenticated/company/': typeof AuthenticatedCompanyIndexRoute
  '/_authenticated/constitution/': typeof AuthenticatedConstitutionIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/departments/': typeof AuthenticatedDepartmentsIndexRoute
  '/_authenticated/goals/': typeof AuthenticatedGoalsIndexRoute
  '/_authenticated/market/': typeof AuthenticatedMarketIndexRoute
  '/_authenticated/principles/': typeof AuthenticatedPrinciplesIndexRoute
  '/_authenticated/strategy/': typeof AuthenticatedStrategyIndexRoute
  '/_authenticated/university/': typeof AuthenticatedUniversityIndexRoute
  '/_authenticated/architect/run/$runId': typeof AuthenticatedArchitectRunRunIdRoute
  '/_authenticated/billing/mock-portal/$ref': typeof AuthenticatedBillingMockPortalRefRoute
  '/_authenticated/brain/entity/$entityId': typeof AuthenticatedBrainEntityEntityIdRoute
  '/_authenticated/brain/library/$sourceId': typeof AuthenticatedBrainLibrarySourceIdRoute
  '/_authenticated/checkout/mock/$ref': typeof AuthenticatedCheckoutMockRefRoute
  '/_authenticated/comms/channels/$accountId': typeof AuthenticatedCommsChannelsAccountIdRoute
  '/_authenticated/comms/rules/$ruleId': typeof AuthenticatedCommsRulesRuleIdRoute
  '/_authenticated/comms/t/$threadId': typeof AuthenticatedCommsTThreadIdRoute
  '/_authenticated/connect/mock/$ref': typeof AuthenticatedConnectMockRefRoute
  '/_authenticated/market/experts/$handle': typeof AuthenticatedMarketExpertsHandleRoute
  '/_authenticated/market/moderation/$caseId': typeof AuthenticatedMarketModerationCaseIdRoute
  '/_authenticated/market/orders/$orderId': typeof AuthenticatedMarketOrdersOrderIdRoute
  '/_authenticated/market/packs/$packId': typeof AuthenticatedMarketPacksPackIdRoute
  '/_authenticated/market/publishers/$handle': typeof AuthenticatedMarketPublishersHandleRoute
  '/_authenticated/university/ab-tests/$testId': typeof AuthenticatedUniversityAbTestsTestIdRoute
  '/_authenticated/university/ab-tests/new': typeof AuthenticatedUniversityAbTestsNewRoute
  '/_authenticated/university/marketplace/$skillId': typeof AuthenticatedUniversityMarketplaceSkillIdRoute
  '/_authenticated/university/skills/$skillId': typeof AuthenticatedUniversitySkillsSkillIdRoute
  '/_authenticated/university/training/$sessionId': typeof AuthenticatedUniversityTrainingSessionIdRoute
  '/_authenticated/university/tuners/$tunerId': typeof AuthenticatedUniversityTunersTunerIdRoute
  '/_authenticated/brain/library/': typeof AuthenticatedBrainLibraryIndexRoute
  '/_authenticated/university/ab-tests/': typeof AuthenticatedUniversityAbTestsIndexRoute
  '/_authenticated/university/marketplace/': typeof AuthenticatedUniversityMarketplaceIndexRoute
  '/_authenticated/university/skills/': typeof AuthenticatedUniversitySkillsIndexRoute
  '/_authenticated/university/training/': typeof AuthenticatedUniversityTrainingIndexRoute
  '/_authenticated/university/tuners/': typeof AuthenticatedUniversityTunersIndexRoute
  '/_authenticated/board/$boardId/card/$cardId': typeof AuthenticatedBoardBoardIdCardCardIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/boards'
    | '/comms'
    | '/files'
    | '/inbox'
    | '/market'
    | '/mission'
    | '/settings-v2'
    | '/welcome'
    | '/architect/dispatch'
    | '/board/$boardId'
    | '/brain/library'
    | '/brain/organize'
    | '/comms/channels'
    | '/comms/drafts'
    | '/comms/inbox'
    | '/comms/rules'
    | '/comms/unsorted'
    | '/company/approval-rules'
    | '/company/connectors'
    | '/company/constitution'
    | '/company/knowledge'
    | '/company/org-chart'
    | '/company/permissions'
    | '/company/roles'
    | '/company/skills'
    | '/company/templates'
    | '/constitution/edit'
    | '/constitution/proposals'
    | '/departments/$deptKey'
    | '/files/$'
    | '/goals/$goalId'
    | '/market/checkout'
    | '/market/checkout-return'
    | '/market/disputes'
    | '/market/engagements'
    | '/market/library'
    | '/market/moderation'
    | '/market/purchases'
    | '/market/sell'
    | '/market/trials'
    | '/project/$projectId'
    | '/settings/access'
    | '/settings/account'
    | '/settings/credentials'
    | '/settings/danger-zone'
    | '/settings/earnings'
    | '/settings/env'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/payments'
    | '/settings/phone-numbers'
    | '/settings/profile'
    | '/settings/provider-tiers'
    | '/settings/resources'
    | '/settings/seller'
    | '/settings/storage'
    | '/settings/supervision'
    | '/settings/telegram'
    | '/settings/usage'
    | '/settings/users'
    | '/settings/workspace'
    | '/university/patterns'
    | '/architect/'
    | '/brain/'
    | '/comms/'
    | '/company/'
    | '/constitution/'
    | '/dashboard/'
    | '/departments/'
    | '/goals/'
    | '/market/'
    | '/principles/'
    | '/strategy/'
    | '/university/'
    | '/architect/run/$runId'
    | '/billing/mock-portal/$ref'
    | '/brain/entity/$entityId'
    | '/brain/library/$sourceId'
    | '/checkout/mock/$ref'
    | '/comms/channels/$accountId'
    | '/comms/rules/$ruleId'
    | '/comms/t/$threadId'
    | '/connect/mock/$ref'
    | '/market/experts/$handle'
    | '/market/moderation/$caseId'
    | '/market/orders/$orderId'
    | '/market/packs/$packId'
    | '/market/publishers/$handle'
    | '/university/ab-tests/$testId'
    | '/university/ab-tests/new'
    | '/university/marketplace/$skillId'
    | '/university/skills/$skillId'
    | '/university/training/$sessionId'
    | '/university/tuners/$tunerId'
    | '/brain/library/'
    | '/university/ab-tests/'
    | '/university/marketplace/'
    | '/university/skills/'
    | '/university/training/'
    | '/university/tuners/'
    | '/board/$boardId/card/$cardId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/boards'
    | '/files'
    | '/inbox'
    | '/mission'
    | '/settings-v2'
    | '/welcome'
    | '/architect/dispatch'
    | '/board/$boardId'
    | '/brain/organize'
    | '/comms/channels'
    | '/comms/drafts'
    | '/comms/inbox'
    | '/comms/rules'
    | '/comms/unsorted'
    | '/company/approval-rules'
    | '/company/connectors'
    | '/company/constitution'
    | '/company/knowledge'
    | '/company/org-chart'
    | '/company/permissions'
    | '/company/roles'
    | '/company/skills'
    | '/company/templates'
    | '/constitution/edit'
    | '/constitution/proposals'
    | '/departments/$deptKey'
    | '/files/$'
    | '/goals/$goalId'
    | '/market/checkout'
    | '/market/checkout-return'
    | '/market/disputes'
    | '/market/engagements'
    | '/market/library'
    | '/market/moderation'
    | '/market/purchases'
    | '/market/sell'
    | '/market/trials'
    | '/project/$projectId'
    | '/settings/access'
    | '/settings/account'
    | '/settings/credentials'
    | '/settings/danger-zone'
    | '/settings/earnings'
    | '/settings/env'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/payments'
    | '/settings/phone-numbers'
    | '/settings/profile'
    | '/settings/provider-tiers'
    | '/settings/resources'
    | '/settings/seller'
    | '/settings/storage'
    | '/settings/supervision'
    | '/settings/telegram'
    | '/settings/usage'
    | '/settings/users'
    | '/settings/workspace'
    | '/university/patterns'
    | '/architect'
    | '/brain'
    | '/comms'
    | '/company'
    | '/constitution'
    | '/dashboard'
    | '/departments'
    | '/goals'
    | '/market'
    | '/principles'
    | '/strategy'
    | '/university'
    | '/architect/run/$runId'
    | '/billing/mock-portal/$ref'
    | '/brain/entity/$entityId'
    | '/brain/library/$sourceId'
    | '/checkout/mock/$ref'
    | '/comms/channels/$accountId'
    | '/comms/rules/$ruleId'
    | '/comms/t/$threadId'
    | '/connect/mock/$ref'
    | '/market/experts/$handle'
    | '/market/moderation/$caseId'
    | '/market/orders/$orderId'
    | '/market/packs/$packId'
    | '/market/publishers/$handle'
    | '/university/ab-tests/$testId'
    | '/university/ab-tests/new'
    | '/university/marketplace/$skillId'
    | '/university/skills/$skillId'
    | '/university/training/$sessionId'
    | '/university/tuners/$tunerId'
    | '/brain/library'
    | '/university/ab-tests'
    | '/university/marketplace'
    | '/university/skills'
    | '/university/training'
    | '/university/tuners'
    | '/board/$boardId/card/$cardId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/_authenticated/boards'
    | '/_authenticated/comms'
    | '/_authenticated/files'
    | '/_authenticated/inbox'
    | '/_authenticated/market'
    | '/_authenticated/mission'
    | '/_authenticated/settings-v2'
    | '/_authenticated/welcome'
    | '/_authenticated/architect/dispatch'
    | '/_authenticated/board/$boardId'
    | '/_authenticated/brain/library'
    | '/_authenticated/brain/organize'
    | '/_authenticated/comms/channels'
    | '/_authenticated/comms/drafts'
    | '/_authenticated/comms/inbox'
    | '/_authenticated/comms/rules'
    | '/_authenticated/comms/unsorted'
    | '/_authenticated/company/approval-rules'
    | '/_authenticated/company/connectors'
    | '/_authenticated/company/constitution'
    | '/_authenticated/company/knowledge'
    | '/_authenticated/company/org-chart'
    | '/_authenticated/company/permissions'
    | '/_authenticated/company/roles'
    | '/_authenticated/company/skills'
    | '/_authenticated/company/templates'
    | '/_authenticated/constitution/edit'
    | '/_authenticated/constitution/proposals'
    | '/_authenticated/departments/$deptKey'
    | '/_authenticated/files/$'
    | '/_authenticated/goals/$goalId'
    | '/_authenticated/market/checkout'
    | '/_authenticated/market/checkout-return'
    | '/_authenticated/market/disputes'
    | '/_authenticated/market/engagements'
    | '/_authenticated/market/library'
    | '/_authenticated/market/moderation'
    | '/_authenticated/market/purchases'
    | '/_authenticated/market/sell'
    | '/_authenticated/market/trials'
    | '/_authenticated/project/$projectId'
    | '/_authenticated/settings/access'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/credentials'
    | '/_authenticated/settings/danger-zone'
    | '/_authenticated/settings/earnings'
    | '/_authenticated/settings/env'
    | '/_authenticated/settings/members'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/payments'
    | '/_authenticated/settings/phone-numbers'
    | '/_authenticated/settings/profile'
    | '/_authenticated/settings/provider-tiers'
    | '/_authenticated/settings/resources'
    | '/_authenticated/settings/seller'
    | '/_authenticated/settings/storage'
    | '/_authenticated/settings/supervision'
    | '/_authenticated/settings/telegram'
    | '/_authenticated/settings/usage'
    | '/_authenticated/settings/users'
    | '/_authenticated/settings/workspace'
    | '/_authenticated/university/patterns'
    | '/_authenticated/architect/'
    | '/_authenticated/brain/'
    | '/_authenticated/comms/'
    | '/_authenticated/company/'
    | '/_authenticated/constitution/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/departments/'
    | '/_authenticated/goals/'
    | '/_authenticated/market/'
    | '/_authenticated/principles/'
    | '/_authenticated/strategy/'
    | '/_authenticated/university/'
    | '/_authenticated/architect/run/$runId'
    | '/_authenticated/billing/mock-portal/$ref'
    | '/_authenticated/brain/entity/$entityId'
    | '/_authenticated/brain/library/$sourceId'
    | '/_authenticated/checkout/mock/$ref'
    | '/_authenticated/comms/channels/$accountId'
    | '/_authenticated/comms/rules/$ruleId'
    | '/_authenticated/comms/t/$threadId'
    | '/_authenticated/connect/mock/$ref'
    | '/_authenticated/market/experts/$handle'
    | '/_authenticated/market/moderation/$caseId'
    | '/_authenticated/market/orders/$orderId'
    | '/_authenticated/market/packs/$packId'
    | '/_authenticated/market/publishers/$handle'
    | '/_authenticated/university/ab-tests/$testId'
    | '/_authenticated/university/ab-tests/new'
    | '/_authenticated/university/marketplace/$skillId'
    | '/_authenticated/university/skills/$skillId'
    | '/_authenticated/university/training/$sessionId'
    | '/_authenticated/university/tuners/$tunerId'
    | '/_authenticated/brain/library/'
    | '/_authenticated/university/ab-tests/'
    | '/_authenticated/university/marketplace/'
    | '/_authenticated/university/skills/'
    | '/_authenticated/university/training/'
    | '/_authenticated/university/tuners/'
    | '/_authenticated/board/$boardId/card/$cardId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/welcome': {
      id: '/_authenticated/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof AuthenticatedWelcomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings-v2': {
      id: '/_authenticated/settings-v2'
      path: '/settings-v2'
      fullPath: '/settings-v2'
      preLoaderRoute: typeof AuthenticatedSettingsV2RouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mission': {
      id: '/_authenticated/mission'
      path: '/mission'
      fullPath: '/mission'
      preLoaderRoute: typeof AuthenticatedMissionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/market': {
      id: '/_authenticated/market'
      path: '/market'
      fullPath: '/market'
      preLoaderRoute: typeof AuthenticatedMarketRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inbox': {
      id: '/_authenticated/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthenticatedInboxRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/files': {
      id: '/_authenticated/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof AuthenticatedFilesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/comms': {
      id: '/_authenticated/comms'
      path: '/comms'
      fullPath: '/comms'
      preLoaderRoute: typeof AuthenticatedCommsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/boards': {
      id: '/_authenticated/boards'
      path: '/boards'
      fullPath: '/boards'
      preLoaderRoute: typeof AuthenticatedBoardsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/': {
      id: '/_authenticated/university/'
      path: '/university'
      fullPath: '/university/'
      preLoaderRoute: typeof AuthenticatedUniversityIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/strategy/': {
      id: '/_authenticated/strategy/'
      path: '/strategy'
      fullPath: '/strategy/'
      preLoaderRoute: typeof AuthenticatedStrategyIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/principles/': {
      id: '/_authenticated/principles/'
      path: '/principles'
      fullPath: '/principles/'
      preLoaderRoute: typeof AuthenticatedPrinciplesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/market/': {
      id: '/_authenticated/market/'
      path: '/'
      fullPath: '/market/'
      preLoaderRoute: typeof AuthenticatedMarketIndexRouteImport
      parentRoute: typeof AuthenticatedMarketRoute
    }
    '/_authenticated/goals/': {
      id: '/_authenticated/goals/'
      path: '/goals'
      fullPath: '/goals/'
      preLoaderRoute: typeof AuthenticatedGoalsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/departments/': {
      id: '/_authenticated/departments/'
      path: '/departments'
      fullPath: '/departments/'
      preLoaderRoute: typeof AuthenticatedDepartmentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/constitution/': {
      id: '/_authenticated/constitution/'
      path: '/constitution'
      fullPath: '/constitution/'
      preLoaderRoute: typeof AuthenticatedConstitutionIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company/': {
      id: '/_authenticated/company/'
      path: '/company'
      fullPath: '/company/'
      preLoaderRoute: typeof AuthenticatedCompanyIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/comms/': {
      id: '/_authenticated/comms/'
      path: '/'
      fullPath: '/comms/'
      preLoaderRoute: typeof AuthenticatedCommsIndexRouteImport
      parentRoute: typeof AuthenticatedCommsRoute
    }
    '/_authenticated/brain/': {
      id: '/_authenticated/brain/'
      path: '/brain'
      fullPath: '/brain/'
      preLoaderRoute: typeof AuthenticatedBrainIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/architect/': {
      id: '/_authenticated/architect/'
      path: '/architect'
      fullPath: '/architect/'
      preLoaderRoute: typeof AuthenticatedArchitectIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/patterns': {
      id: '/_authenticated/university/patterns'
      path: '/university/patterns'
      fullPath: '/university/patterns'
      preLoaderRoute: typeof AuthenticatedUniversityPatternsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/workspace': {
      id: '/_authenticated/settings/workspace'
      path: '/settings/workspace'
      fullPath: '/settings/workspace'
      preLoaderRoute: typeof AuthenticatedSettingsWorkspaceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/users': {
      id: '/_authenticated/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthenticatedSettingsUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/usage': {
      id: '/_authenticated/settings/usage'
      path: '/settings/usage'
      fullPath: '/settings/usage'
      preLoaderRoute: typeof AuthenticatedSettingsUsageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/telegram': {
      id: '/_authenticated/settings/telegram'
      path: '/settings/telegram'
      fullPath: '/settings/telegram'
      preLoaderRoute: typeof AuthenticatedSettingsTelegramRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/supervision': {
      id: '/_authenticated/settings/supervision'
      path: '/settings/supervision'
      fullPath: '/settings/supervision'
      preLoaderRoute: typeof AuthenticatedSettingsSupervisionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/storage': {
      id: '/_authenticated/settings/storage'
      path: '/settings/storage'
      fullPath: '/settings/storage'
      preLoaderRoute: typeof AuthenticatedSettingsStorageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/seller': {
      id: '/_authenticated/settings/seller'
      path: '/settings/seller'
      fullPath: '/settings/seller'
      preLoaderRoute: typeof AuthenticatedSettingsSellerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/resources': {
      id: '/_authenticated/settings/resources'
      path: '/settings/resources'
      fullPath: '/settings/resources'
      preLoaderRoute: typeof AuthenticatedSettingsResourcesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/provider-tiers': {
      id: '/_authenticated/settings/provider-tiers'
      path: '/settings/provider-tiers'
      fullPath: '/settings/provider-tiers'
      preLoaderRoute: typeof AuthenticatedSettingsProviderTiersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/phone-numbers': {
      id: '/_authenticated/settings/phone-numbers'
      path: '/settings/phone-numbers'
      fullPath: '/settings/phone-numbers'
      preLoaderRoute: typeof AuthenticatedSettingsPhoneNumbersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/payments': {
      id: '/_authenticated/settings/payments'
      path: '/settings/payments'
      fullPath: '/settings/payments'
      preLoaderRoute: typeof AuthenticatedSettingsPaymentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/members': {
      id: '/_authenticated/settings/members'
      path: '/settings/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AuthenticatedSettingsMembersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/env': {
      id: '/_authenticated/settings/env'
      path: '/settings/env'
      fullPath: '/settings/env'
      preLoaderRoute: typeof AuthenticatedSettingsEnvRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/earnings': {
      id: '/_authenticated/settings/earnings'
      path: '/settings/earnings'
      fullPath: '/settings/earnings'
      preLoaderRoute: typeof AuthenticatedSettingsEarningsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/danger-zone': {
      id: '/_authenticated/settings/danger-zone'
      path: '/settings/danger-zone'
      fullPath: '/settings/danger-zone'
      preLoaderRoute: typeof AuthenticatedSettingsDangerZoneRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/credentials': {
      id: '/_authenticated/settings/credentials'
      path: '/settings/credentials'
      fullPath: '/settings/credentials'
      preLoaderRoute: typeof AuthenticatedSettingsCredentialsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/access': {
      id: '/_authenticated/settings/access'
      path: '/settings/access'
      fullPath: '/settings/access'
      preLoaderRoute: typeof AuthenticatedSettingsAccessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/project/$projectId': {
      id: '/_authenticated/project/$projectId'
      path: '/project/$projectId'
      fullPath: '/project/$projectId'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/market/trials': {
      id: '/_authenticated/market/trials'
      path: '/trials'
      fullPath: '/market/trials'
      preLoaderRoute: typeof AuthenticatedMarketTrialsRouteImport
      parentRoute: typeof AuthenticatedMarketRoute
    }
    '/_authenticated/market/sell': {
      id: '/_authenticated/market/sell'
      path: '/sell'
      fullPath: '/market/sell'
      preLoaderRoute: typeof AuthenticatedMarketSellRouteImport
      parentRoute: typeof AuthenticatedMarketRoute
    }
    '/_authenticated/market/purchases': {
      id: '/_authenticated/market/purchases'
      path: '/purchases'
      fullPath: '/market/purchases'
      preLoaderRoute: typeof AuthenticatedMarketPurchasesRouteImport
      parentRoute: typeof AuthenticatedMarketRoute
    }
    '/_authenticated/market/moderation': {
      id: '/_authenticated/market/moderation'
      path: '/moderation'
      fullPath: '/market/moderation'
      preLoaderRoute: typeof AuthenticatedMarketModerationRouteImport
      parentRoute: typeof AuthenticatedMarketRoute
    }
    '/_authenticated/market/library': {
      id: '/_authenticated/market/library'
      path: '/library'
      fullPath: '/market/library'
      preLoaderRoute: typeof AuthenticatedMarketLibraryRouteImport
      parentRoute: typeof AuthenticatedMarketRoute
    }
    '/_authenticated/market/engagements': {
      id: '/_authenticated/market/engagements'
      path: '/engagements'
      fullPath: '/market/engagements'
      preLoaderRoute: typeof AuthenticatedMarketEngagementsRouteImport
      parentRoute: typeof AuthenticatedMarketRoute
    }
    '/_authenticated/market/disputes': {
      id: '/_authenticated/market/disputes'
      path: '/disputes'
      fullPath: '/market/disputes'
      preLoaderRoute: typeof AuthenticatedMarketDisputesRouteImport
      parentRoute: typeof AuthenticatedMarketRoute
    }
    '/_authenticated/market/checkout-return': {
      id: '/_authenticated/market/checkout-return'
      path: '/checkout-return'
      fullPath: '/market/checkout-return'
      preLoaderRoute: typeof AuthenticatedMarketCheckoutReturnRouteImport
      parentRoute: typeof AuthenticatedMarketRoute
    }
    '/_authenticated/market/checkout': {
      id: '/_authenticated/market/checkout'
      path: '/checkout'
      fullPath: '/market/checkout'
      preLoaderRoute: typeof AuthenticatedMarketCheckoutRouteImport
      parentRoute: typeof AuthenticatedMarketRoute
    }
    '/_authenticated/goals/$goalId': {
      id: '/_authenticated/goals/$goalId'
      path: '/goals/$goalId'
      fullPath: '/goals/$goalId'
      preLoaderRoute: typeof AuthenticatedGoalsGoalIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/files/$': {
      id: '/_authenticated/files/$'
      path: '/$'
      fullPath: '/files/$'
      preLoaderRoute: typeof AuthenticatedFilesSplatRouteImport
      parentRoute: typeof AuthenticatedFilesRoute
    }
    '/_authenticated/departments/$deptKey': {
      id: '/_authenticated/departments/$deptKey'
      path: '/departments/$deptKey'
      fullPath: '/departments/$deptKey'
      preLoaderRoute: typeof AuthenticatedDepartmentsDeptKeyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/constitution/proposals': {
      id: '/_authenticated/constitution/proposals'
      path: '/constitution/proposals'
      fullPath: '/constitution/proposals'
      preLoaderRoute: typeof AuthenticatedConstitutionProposalsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/constitution/edit': {
      id: '/_authenticated/constitution/edit'
      path: '/constitution/edit'
      fullPath: '/constitution/edit'
      preLoaderRoute: typeof AuthenticatedConstitutionEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company/templates': {
      id: '/_authenticated/company/templates'
      path: '/company/templates'
      fullPath: '/company/templates'
      preLoaderRoute: typeof AuthenticatedCompanyTemplatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company/skills': {
      id: '/_authenticated/company/skills'
      path: '/company/skills'
      fullPath: '/company/skills'
      preLoaderRoute: typeof AuthenticatedCompanySkillsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company/roles': {
      id: '/_authenticated/company/roles'
      path: '/company/roles'
      fullPath: '/company/roles'
      preLoaderRoute: typeof AuthenticatedCompanyRolesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company/permissions': {
      id: '/_authenticated/company/permissions'
      path: '/company/permissions'
      fullPath: '/company/permissions'
      preLoaderRoute: typeof AuthenticatedCompanyPermissionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company/org-chart': {
      id: '/_authenticated/company/org-chart'
      path: '/company/org-chart'
      fullPath: '/company/org-chart'
      preLoaderRoute: typeof AuthenticatedCompanyOrgChartRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company/knowledge': {
      id: '/_authenticated/company/knowledge'
      path: '/company/knowledge'
      fullPath: '/company/knowledge'
      preLoaderRoute: typeof AuthenticatedCompanyKnowledgeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company/constitution': {
      id: '/_authenticated/company/constitution'
      path: '/company/constitution'
      fullPath: '/company/constitution'
      preLoaderRoute: typeof AuthenticatedCompanyConstitutionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company/connectors': {
      id: '/_authenticated/company/connectors'
      path: '/company/connectors'
      fullPath: '/company/connectors'
      preLoaderRoute: typeof AuthenticatedCompanyConnectorsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company/approval-rules': {
      id: '/_authenticated/company/approval-rules'
      path: '/company/approval-rules'
      fullPath: '/company/approval-rules'
      preLoaderRoute: typeof AuthenticatedCompanyApprovalRulesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/comms/unsorted': {
      id: '/_authenticated/comms/unsorted'
      path: '/unsorted'
      fullPath: '/comms/unsorted'
      preLoaderRoute: typeof AuthenticatedCommsUnsortedRouteImport
      parentRoute: typeof AuthenticatedCommsRoute
    }
    '/_authenticated/comms/rules': {
      id: '/_authenticated/comms/rules'
      path: '/rules'
      fullPath: '/comms/rules'
      preLoaderRoute: typeof AuthenticatedCommsRulesRouteImport
      parentRoute: typeof AuthenticatedCommsRoute
    }
    '/_authenticated/comms/inbox': {
      id: '/_authenticated/comms/inbox'
      path: '/inbox'
      fullPath: '/comms/inbox'
      preLoaderRoute: typeof AuthenticatedCommsInboxRouteImport
      parentRoute: typeof AuthenticatedCommsRoute
    }
    '/_authenticated/comms/drafts': {
      id: '/_authenticated/comms/drafts'
      path: '/drafts'
      fullPath: '/comms/drafts'
      preLoaderRoute: typeof AuthenticatedCommsDraftsRouteImport
      parentRoute: typeof AuthenticatedCommsRoute
    }
    '/_authenticated/comms/channels': {
      id: '/_authenticated/comms/channels'
      path: '/channels'
      fullPath: '/comms/channels'
      preLoaderRoute: typeof AuthenticatedCommsChannelsRouteImport
      parentRoute: typeof AuthenticatedCommsRoute
    }
    '/_authenticated/brain/organize': {
      id: '/_authenticated/brain/organize'
      path: '/brain/organize'
      fullPath: '/brain/organize'
      preLoaderRoute: typeof AuthenticatedBrainOrganizeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/brain/library': {
      id: '/_authenticated/brain/library'
      path: '/brain/library'
      fullPath: '/brain/library'
      preLoaderRoute: typeof AuthenticatedBrainLibraryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/board/$boardId': {
      id: '/_authenticated/board/$boardId'
      path: '/board/$boardId'
      fullPath: '/board/$boardId'
      preLoaderRoute: typeof AuthenticatedBoardBoardIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/architect/dispatch': {
      id: '/_authenticated/architect/dispatch'
      path: '/architect/dispatch'
      fullPath: '/architect/dispatch'
      preLoaderRoute: typeof AuthenticatedArchitectDispatchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/tuners/': {
      id: '/_authenticated/university/tuners/'
      path: '/university/tuners'
      fullPath: '/university/tuners/'
      preLoaderRoute: typeof AuthenticatedUniversityTunersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/training/': {
      id: '/_authenticated/university/training/'
      path: '/university/training'
      fullPath: '/university/training/'
      preLoaderRoute: typeof AuthenticatedUniversityTrainingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/skills/': {
      id: '/_authenticated/university/skills/'
      path: '/university/skills'
      fullPath: '/university/skills/'
      preLoaderRoute: typeof AuthenticatedUniversitySkillsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/marketplace/': {
      id: '/_authenticated/university/marketplace/'
      path: '/university/marketplace'
      fullPath: '/university/marketplace/'
      preLoaderRoute: typeof AuthenticatedUniversityMarketplaceIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/ab-tests/': {
      id: '/_authenticated/university/ab-tests/'
      path: '/university/ab-tests'
      fullPath: '/university/ab-tests/'
      preLoaderRoute: typeof AuthenticatedUniversityAbTestsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/brain/library/': {
      id: '/_authenticated/brain/library/'
      path: '/'
      fullPath: '/brain/library/'
      preLoaderRoute: typeof AuthenticatedBrainLibraryIndexRouteImport
      parentRoute: typeof AuthenticatedBrainLibraryRoute
    }
    '/_authenticated/university/tuners/$tunerId': {
      id: '/_authenticated/university/tuners/$tunerId'
      path: '/university/tuners/$tunerId'
      fullPath: '/university/tuners/$tunerId'
      preLoaderRoute: typeof AuthenticatedUniversityTunersTunerIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/training/$sessionId': {
      id: '/_authenticated/university/training/$sessionId'
      path: '/university/training/$sessionId'
      fullPath: '/university/training/$sessionId'
      preLoaderRoute: typeof AuthenticatedUniversityTrainingSessionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/skills/$skillId': {
      id: '/_authenticated/university/skills/$skillId'
      path: '/university/skills/$skillId'
      fullPath: '/university/skills/$skillId'
      preLoaderRoute: typeof AuthenticatedUniversitySkillsSkillIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/marketplace/$skillId': {
      id: '/_authenticated/university/marketplace/$skillId'
      path: '/university/marketplace/$skillId'
      fullPath: '/university/marketplace/$skillId'
      preLoaderRoute: typeof AuthenticatedUniversityMarketplaceSkillIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/ab-tests/new': {
      id: '/_authenticated/university/ab-tests/new'
      path: '/university/ab-tests/new'
      fullPath: '/university/ab-tests/new'
      preLoaderRoute: typeof AuthenticatedUniversityAbTestsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/ab-tests/$testId': {
      id: '/_authenticated/university/ab-tests/$testId'
      path: '/university/ab-tests/$testId'
      fullPath: '/university/ab-tests/$testId'
      preLoaderRoute: typeof AuthenticatedUniversityAbTestsTestIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/market/publishers/$handle': {
      id: '/_authenticated/market/publishers/$handle'
      path: '/publishers/$handle'
      fullPath: '/market/publishers/$handle'
      preLoaderRoute: typeof AuthenticatedMarketPublishersHandleRouteImport
      parentRoute: typeof AuthenticatedMarketRoute
    }
    '/_authenticated/market/packs/$packId': {
      id: '/_authenticated/market/packs/$packId'
      path: '/packs/$packId'
      fullPath: '/market/packs/$packId'
      preLoaderRoute: typeof AuthenticatedMarketPacksPackIdRouteImport
      parentRoute: typeof AuthenticatedMarketRoute
    }
    '/_authenticated/market/orders/$orderId': {
      id: '/_authenticated/market/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/market/orders/$orderId'
      preLoaderRoute: typeof AuthenticatedMarketOrdersOrderIdRouteImport
      parentRoute: typeof AuthenticatedMarketRoute
    }
    '/_authenticated/market/moderation/$caseId': {
      id: '/_authenticated/market/moderation/$caseId'
      path: '/$caseId'
      fullPath: '/market/moderation/$caseId'
      preLoaderRoute: typeof AuthenticatedMarketModerationCaseIdRouteImport
      parentRoute: typeof AuthenticatedMarketModerationRoute
    }
    '/_authenticated/market/experts/$handle': {
      id: '/_authenticated/market/experts/$handle'
      path: '/experts/$handle'
      fullPath: '/market/experts/$handle'
      preLoaderRoute: typeof AuthenticatedMarketExpertsHandleRouteImport
      parentRoute: typeof AuthenticatedMarketRoute
    }
    '/_authenticated/connect/mock/$ref': {
      id: '/_authenticated/connect/mock/$ref'
      path: '/connect/mock/$ref'
      fullPath: '/connect/mock/$ref'
      preLoaderRoute: typeof AuthenticatedConnectMockRefRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/comms/t/$threadId': {
      id: '/_authenticated/comms/t/$threadId'
      path: '/t/$threadId'
      fullPath: '/comms/t/$threadId'
      preLoaderRoute: typeof AuthenticatedCommsTThreadIdRouteImport
      parentRoute: typeof AuthenticatedCommsRoute
    }
    '/_authenticated/comms/rules/$ruleId': {
      id: '/_authenticated/comms/rules/$ruleId'
      path: '/$ruleId'
      fullPath: '/comms/rules/$ruleId'
      preLoaderRoute: typeof AuthenticatedCommsRulesRuleIdRouteImport
      parentRoute: typeof AuthenticatedCommsRulesRoute
    }
    '/_authenticated/comms/channels/$accountId': {
      id: '/_authenticated/comms/channels/$accountId'
      path: '/$accountId'
      fullPath: '/comms/channels/$accountId'
      preLoaderRoute: typeof AuthenticatedCommsChannelsAccountIdRouteImport
      parentRoute: typeof AuthenticatedCommsChannelsRoute
    }
    '/_authenticated/checkout/mock/$ref': {
      id: '/_authenticated/checkout/mock/$ref'
      path: '/checkout/mock/$ref'
      fullPath: '/checkout/mock/$ref'
      preLoaderRoute: typeof AuthenticatedCheckoutMockRefRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/brain/library/$sourceId': {
      id: '/_authenticated/brain/library/$sourceId'
      path: '/$sourceId'
      fullPath: '/brain/library/$sourceId'
      preLoaderRoute: typeof AuthenticatedBrainLibrarySourceIdRouteImport
      parentRoute: typeof AuthenticatedBrainLibraryRoute
    }
    '/_authenticated/brain/entity/$entityId': {
      id: '/_authenticated/brain/entity/$entityId'
      path: '/brain/entity/$entityId'
      fullPath: '/brain/entity/$entityId'
      preLoaderRoute: typeof AuthenticatedBrainEntityEntityIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/billing/mock-portal/$ref': {
      id: '/_authenticated/billing/mock-portal/$ref'
      path: '/billing/mock-portal/$ref'
      fullPath: '/billing/mock-portal/$ref'
      preLoaderRoute: typeof AuthenticatedBillingMockPortalRefRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/architect/run/$runId': {
      id: '/_authenticated/architect/run/$runId'
      path: '/architect/run/$runId'
      fullPath: '/architect/run/$runId'
      preLoaderRoute: typeof AuthenticatedArchitectRunRunIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/board/$boardId/card/$cardId': {
      id: '/_authenticated/board/$boardId/card/$cardId'
      path: '/card/$cardId'
      fullPath: '/board/$boardId/card/$cardId'
      preLoaderRoute: typeof AuthenticatedBoardBoardIdCardCardIdRouteImport
      parentRoute: typeof AuthenticatedBoardBoardIdRoute
    }
  }
}

interface AuthenticatedCommsChannelsRouteChildren {
  AuthenticatedCommsChannelsAccountIdRoute: typeof AuthenticatedCommsChannelsAccountIdRoute
}

const AuthenticatedCommsChannelsRouteChildren: AuthenticatedCommsChannelsRouteChildren =
  {
    AuthenticatedCommsChannelsAccountIdRoute:
      AuthenticatedCommsChannelsAccountIdRoute,
  }

const AuthenticatedCommsChannelsRouteWithChildren =
  AuthenticatedCommsChannelsRoute._addFileChildren(
    AuthenticatedCommsChannelsRouteChildren,
  )

interface AuthenticatedCommsRulesRouteChildren {
  AuthenticatedCommsRulesRuleIdRoute: typeof AuthenticatedCommsRulesRuleIdRoute
}

const AuthenticatedCommsRulesRouteChildren: AuthenticatedCommsRulesRouteChildren =
  {
    AuthenticatedCommsRulesRuleIdRoute: AuthenticatedCommsRulesRuleIdRoute,
  }

const AuthenticatedCommsRulesRouteWithChildren =
  AuthenticatedCommsRulesRoute._addFileChildren(
    AuthenticatedCommsRulesRouteChildren,
  )

interface AuthenticatedCommsRouteChildren {
  AuthenticatedCommsChannelsRoute: typeof AuthenticatedCommsChannelsRouteWithChildren
  AuthenticatedCommsDraftsRoute: typeof AuthenticatedCommsDraftsRoute
  AuthenticatedCommsInboxRoute: typeof AuthenticatedCommsInboxRoute
  AuthenticatedCommsRulesRoute: typeof AuthenticatedCommsRulesRouteWithChildren
  AuthenticatedCommsUnsortedRoute: typeof AuthenticatedCommsUnsortedRoute
  AuthenticatedCommsIndexRoute: typeof AuthenticatedCommsIndexRoute
  AuthenticatedCommsTThreadIdRoute: typeof AuthenticatedCommsTThreadIdRoute
}

const AuthenticatedCommsRouteChildren: AuthenticatedCommsRouteChildren = {
  AuthenticatedCommsChannelsRoute: AuthenticatedCommsChannelsRouteWithChildren,
  AuthenticatedCommsDraftsRoute: AuthenticatedCommsDraftsRoute,
  AuthenticatedCommsInboxRoute: AuthenticatedCommsInboxRoute,
  AuthenticatedCommsRulesRoute: AuthenticatedCommsRulesRouteWithChildren,
  AuthenticatedCommsUnsortedRoute: AuthenticatedCommsUnsortedRoute,
  AuthenticatedCommsIndexRoute: AuthenticatedCommsIndexRoute,
  AuthenticatedCommsTThreadIdRoute: AuthenticatedCommsTThreadIdRoute,
}

const AuthenticatedCommsRouteWithChildren =
  AuthenticatedCommsRoute._addFileChildren(AuthenticatedCommsRouteChildren)

interface AuthenticatedFilesRouteChildren {
  AuthenticatedFilesSplatRoute: typeof AuthenticatedFilesSplatRoute
}

const AuthenticatedFilesRouteChildren: AuthenticatedFilesRouteChildren = {
  AuthenticatedFilesSplatRoute: AuthenticatedFilesSplatRoute,
}

const AuthenticatedFilesRouteWithChildren =
  AuthenticatedFilesRoute._addFileChildren(AuthenticatedFilesRouteChildren)

interface AuthenticatedMarketModerationRouteChildren {
  AuthenticatedMarketModerationCaseIdRoute: typeof AuthenticatedMarketModerationCaseIdRoute
}

const AuthenticatedMarketModerationRouteChildren: AuthenticatedMarketModerationRouteChildren =
  {
    AuthenticatedMarketModerationCaseIdRoute:
      AuthenticatedMarketModerationCaseIdRoute,
  }

const AuthenticatedMarketModerationRouteWithChildren =
  AuthenticatedMarketModerationRoute._addFileChildren(
    AuthenticatedMarketModerationRouteChildren,
  )

interface AuthenticatedMarketRouteChildren {
  AuthenticatedMarketCheckoutRoute: typeof AuthenticatedMarketCheckoutRoute
  AuthenticatedMarketCheckoutReturnRoute: typeof AuthenticatedMarketCheckoutReturnRoute
  AuthenticatedMarketDisputesRoute: typeof AuthenticatedMarketDisputesRoute
  AuthenticatedMarketEngagementsRoute: typeof AuthenticatedMarketEngagementsRoute
  AuthenticatedMarketLibraryRoute: typeof AuthenticatedMarketLibraryRoute
  AuthenticatedMarketModerationRoute: typeof AuthenticatedMarketModerationRouteWithChildren
  AuthenticatedMarketPurchasesRoute: typeof AuthenticatedMarketPurchasesRoute
  AuthenticatedMarketSellRoute: typeof AuthenticatedMarketSellRoute
  AuthenticatedMarketTrialsRoute: typeof AuthenticatedMarketTrialsRoute
  AuthenticatedMarketIndexRoute: typeof AuthenticatedMarketIndexRoute
  AuthenticatedMarketExpertsHandleRoute: typeof AuthenticatedMarketExpertsHandleRoute
  AuthenticatedMarketOrdersOrderIdRoute: typeof AuthenticatedMarketOrdersOrderIdRoute
  AuthenticatedMarketPacksPackIdRoute: typeof AuthenticatedMarketPacksPackIdRoute
  AuthenticatedMarketPublishersHandleRoute: typeof AuthenticatedMarketPublishersHandleRoute
}

const AuthenticatedMarketRouteChildren: AuthenticatedMarketRouteChildren = {
  AuthenticatedMarketCheckoutRoute: AuthenticatedMarketCheckoutRoute,
  AuthenticatedMarketCheckoutReturnRoute:
    AuthenticatedMarketCheckoutReturnRoute,
  AuthenticatedMarketDisputesRoute: AuthenticatedMarketDisputesRoute,
  AuthenticatedMarketEngagementsRoute: AuthenticatedMarketEngagementsRoute,
  AuthenticatedMarketLibraryRoute: AuthenticatedMarketLibraryRoute,
  AuthenticatedMarketModerationRoute:
    AuthenticatedMarketModerationRouteWithChildren,
  AuthenticatedMarketPurchasesRoute: AuthenticatedMarketPurchasesRoute,
  AuthenticatedMarketSellRoute: AuthenticatedMarketSellRoute,
  AuthenticatedMarketTrialsRoute: AuthenticatedMarketTrialsRoute,
  AuthenticatedMarketIndexRoute: AuthenticatedMarketIndexRoute,
  AuthenticatedMarketExpertsHandleRoute: AuthenticatedMarketExpertsHandleRoute,
  AuthenticatedMarketOrdersOrderIdRoute: AuthenticatedMarketOrdersOrderIdRoute,
  AuthenticatedMarketPacksPackIdRoute: AuthenticatedMarketPacksPackIdRoute,
  AuthenticatedMarketPublishersHandleRoute:
    AuthenticatedMarketPublishersHandleRoute,
}

const AuthenticatedMarketRouteWithChildren =
  AuthenticatedMarketRoute._addFileChildren(AuthenticatedMarketRouteChildren)

interface AuthenticatedBoardBoardIdRouteChildren {
  AuthenticatedBoardBoardIdCardCardIdRoute: typeof AuthenticatedBoardBoardIdCardCardIdRoute
}

const AuthenticatedBoardBoardIdRouteChildren: AuthenticatedBoardBoardIdRouteChildren =
  {
    AuthenticatedBoardBoardIdCardCardIdRoute:
      AuthenticatedBoardBoardIdCardCardIdRoute,
  }

const AuthenticatedBoardBoardIdRouteWithChildren =
  AuthenticatedBoardBoardIdRoute._addFileChildren(
    AuthenticatedBoardBoardIdRouteChildren,
  )

interface AuthenticatedBrainLibraryRouteChildren {
  AuthenticatedBrainLibrarySourceIdRoute: typeof AuthenticatedBrainLibrarySourceIdRoute
  AuthenticatedBrainLibraryIndexRoute: typeof AuthenticatedBrainLibraryIndexRoute
}

const AuthenticatedBrainLibraryRouteChildren: AuthenticatedBrainLibraryRouteChildren =
  {
    AuthenticatedBrainLibrarySourceIdRoute:
      AuthenticatedBrainLibrarySourceIdRoute,
    AuthenticatedBrainLibraryIndexRoute: AuthenticatedBrainLibraryIndexRoute,
  }

const AuthenticatedBrainLibraryRouteWithChildren =
  AuthenticatedBrainLibraryRoute._addFileChildren(
    AuthenticatedBrainLibraryRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedBoardsRoute: typeof AuthenticatedBoardsRoute
  AuthenticatedCommsRoute: typeof AuthenticatedCommsRouteWithChildren
  AuthenticatedFilesRoute: typeof AuthenticatedFilesRouteWithChildren
  AuthenticatedInboxRoute: typeof AuthenticatedInboxRoute
  AuthenticatedMarketRoute: typeof AuthenticatedMarketRouteWithChildren
  AuthenticatedMissionRoute: typeof AuthenticatedMissionRoute
  AuthenticatedSettingsV2Route: typeof AuthenticatedSettingsV2Route
  AuthenticatedWelcomeRoute: typeof AuthenticatedWelcomeRoute
  AuthenticatedArchitectDispatchRoute: typeof AuthenticatedArchitectDispatchRoute
  AuthenticatedBoardBoardIdRoute: typeof AuthenticatedBoardBoardIdRouteWithChildren
  AuthenticatedBrainLibraryRoute: typeof AuthenticatedBrainLibraryRouteWithChildren
  AuthenticatedBrainOrganizeRoute: typeof AuthenticatedBrainOrganizeRoute
  AuthenticatedCompanyApprovalRulesRoute: typeof AuthenticatedCompanyApprovalRulesRoute
  AuthenticatedCompanyConnectorsRoute: typeof AuthenticatedCompanyConnectorsRoute
  AuthenticatedCompanyConstitutionRoute: typeof AuthenticatedCompanyConstitutionRoute
  AuthenticatedCompanyKnowledgeRoute: typeof AuthenticatedCompanyKnowledgeRoute
  AuthenticatedCompanyOrgChartRoute: typeof AuthenticatedCompanyOrgChartRoute
  AuthenticatedCompanyPermissionsRoute: typeof AuthenticatedCompanyPermissionsRoute
  AuthenticatedCompanyRolesRoute: typeof AuthenticatedCompanyRolesRoute
  AuthenticatedCompanySkillsRoute: typeof AuthenticatedCompanySkillsRoute
  AuthenticatedCompanyTemplatesRoute: typeof AuthenticatedCompanyTemplatesRoute
  AuthenticatedConstitutionEditRoute: typeof AuthenticatedConstitutionEditRoute
  AuthenticatedConstitutionProposalsRoute: typeof AuthenticatedConstitutionProposalsRoute
  AuthenticatedDepartmentsDeptKeyRoute: typeof AuthenticatedDepartmentsDeptKeyRoute
  AuthenticatedGoalsGoalIdRoute: typeof AuthenticatedGoalsGoalIdRoute
  AuthenticatedProjectProjectIdRoute: typeof AuthenticatedProjectProjectIdRoute
  AuthenticatedSettingsAccessRoute: typeof AuthenticatedSettingsAccessRoute
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsCredentialsRoute: typeof AuthenticatedSettingsCredentialsRoute
  AuthenticatedSettingsDangerZoneRoute: typeof AuthenticatedSettingsDangerZoneRoute
  AuthenticatedSettingsEarningsRoute: typeof AuthenticatedSettingsEarningsRoute
  AuthenticatedSettingsEnvRoute: typeof AuthenticatedSettingsEnvRoute
  AuthenticatedSettingsMembersRoute: typeof AuthenticatedSettingsMembersRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsPaymentsRoute: typeof AuthenticatedSettingsPaymentsRoute
  AuthenticatedSettingsPhoneNumbersRoute: typeof AuthenticatedSettingsPhoneNumbersRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedSettingsProviderTiersRoute: typeof AuthenticatedSettingsProviderTiersRoute
  AuthenticatedSettingsResourcesRoute: typeof AuthenticatedSettingsResourcesRoute
  AuthenticatedSettingsSellerRoute: typeof AuthenticatedSettingsSellerRoute
  AuthenticatedSettingsStorageRoute: typeof AuthenticatedSettingsStorageRoute
  AuthenticatedSettingsSupervisionRoute: typeof AuthenticatedSettingsSupervisionRoute
  AuthenticatedSettingsTelegramRoute: typeof AuthenticatedSettingsTelegramRoute
  AuthenticatedSettingsUsageRoute: typeof AuthenticatedSettingsUsageRoute
  AuthenticatedSettingsUsersRoute: typeof AuthenticatedSettingsUsersRoute
  AuthenticatedSettingsWorkspaceRoute: typeof AuthenticatedSettingsWorkspaceRoute
  AuthenticatedUniversityPatternsRoute: typeof AuthenticatedUniversityPatternsRoute
  AuthenticatedArchitectIndexRoute: typeof AuthenticatedArchitectIndexRoute
  AuthenticatedBrainIndexRoute: typeof AuthenticatedBrainIndexRoute
  AuthenticatedCompanyIndexRoute: typeof AuthenticatedCompanyIndexRoute
  AuthenticatedConstitutionIndexRoute: typeof AuthenticatedConstitutionIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedDepartmentsIndexRoute: typeof AuthenticatedDepartmentsIndexRoute
  AuthenticatedGoalsIndexRoute: typeof AuthenticatedGoalsIndexRoute
  AuthenticatedPrinciplesIndexRoute: typeof AuthenticatedPrinciplesIndexRoute
  AuthenticatedStrategyIndexRoute: typeof AuthenticatedStrategyIndexRoute
  AuthenticatedUniversityIndexRoute: typeof AuthenticatedUniversityIndexRoute
  AuthenticatedArchitectRunRunIdRoute: typeof AuthenticatedArchitectRunRunIdRoute
  AuthenticatedBillingMockPortalRefRoute: typeof AuthenticatedBillingMockPortalRefRoute
  AuthenticatedBrainEntityEntityIdRoute: typeof AuthenticatedBrainEntityEntityIdRoute
  AuthenticatedCheckoutMockRefRoute: typeof AuthenticatedCheckoutMockRefRoute
  AuthenticatedConnectMockRefRoute: typeof AuthenticatedConnectMockRefRoute
  AuthenticatedUniversityAbTestsTestIdRoute: typeof AuthenticatedUniversityAbTestsTestIdRoute
  AuthenticatedUniversityAbTestsNewRoute: typeof AuthenticatedUniversityAbTestsNewRoute
  AuthenticatedUniversityMarketplaceSkillIdRoute: typeof AuthenticatedUniversityMarketplaceSkillIdRoute
  AuthenticatedUniversitySkillsSkillIdRoute: typeof AuthenticatedUniversitySkillsSkillIdRoute
  AuthenticatedUniversityTrainingSessionIdRoute: typeof AuthenticatedUniversityTrainingSessionIdRoute
  AuthenticatedUniversityTunersTunerIdRoute: typeof AuthenticatedUniversityTunersTunerIdRoute
  AuthenticatedUniversityAbTestsIndexRoute: typeof AuthenticatedUniversityAbTestsIndexRoute
  AuthenticatedUniversityMarketplaceIndexRoute: typeof AuthenticatedUniversityMarketplaceIndexRoute
  AuthenticatedUniversitySkillsIndexRoute: typeof AuthenticatedUniversitySkillsIndexRoute
  AuthenticatedUniversityTrainingIndexRoute: typeof AuthenticatedUniversityTrainingIndexRoute
  AuthenticatedUniversityTunersIndexRoute: typeof AuthenticatedUniversityTunersIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedBoardsRoute: AuthenticatedBoardsRoute,
  AuthenticatedCommsRoute: AuthenticatedCommsRouteWithChildren,
  AuthenticatedFilesRoute: AuthenticatedFilesRouteWithChildren,
  AuthenticatedInboxRoute: AuthenticatedInboxRoute,
  AuthenticatedMarketRoute: AuthenticatedMarketRouteWithChildren,
  AuthenticatedMissionRoute: AuthenticatedMissionRoute,
  AuthenticatedSettingsV2Route: AuthenticatedSettingsV2Route,
  AuthenticatedWelcomeRoute: AuthenticatedWelcomeRoute,
  AuthenticatedArchitectDispatchRoute: AuthenticatedArchitectDispatchRoute,
  AuthenticatedBoardBoardIdRoute: AuthenticatedBoardBoardIdRouteWithChildren,
  AuthenticatedBrainLibraryRoute: AuthenticatedBrainLibraryRouteWithChildren,
  AuthenticatedBrainOrganizeRoute: AuthenticatedBrainOrganizeRoute,
  AuthenticatedCompanyApprovalRulesRoute:
    AuthenticatedCompanyApprovalRulesRoute,
  AuthenticatedCompanyConnectorsRoute: AuthenticatedCompanyConnectorsRoute,
  AuthenticatedCompanyConstitutionRoute: AuthenticatedCompanyConstitutionRoute,
  AuthenticatedCompanyKnowledgeRoute: AuthenticatedCompanyKnowledgeRoute,
  AuthenticatedCompanyOrgChartRoute: AuthenticatedCompanyOrgChartRoute,
  AuthenticatedCompanyPermissionsRoute: AuthenticatedCompanyPermissionsRoute,
  AuthenticatedCompanyRolesRoute: AuthenticatedCompanyRolesRoute,
  AuthenticatedCompanySkillsRoute: AuthenticatedCompanySkillsRoute,
  AuthenticatedCompanyTemplatesRoute: AuthenticatedCompanyTemplatesRoute,
  AuthenticatedConstitutionEditRoute: AuthenticatedConstitutionEditRoute,
  AuthenticatedConstitutionProposalsRoute:
    AuthenticatedConstitutionProposalsRoute,
  AuthenticatedDepartmentsDeptKeyRoute: AuthenticatedDepartmentsDeptKeyRoute,
  AuthenticatedGoalsGoalIdRoute: AuthenticatedGoalsGoalIdRoute,
  AuthenticatedProjectProjectIdRoute: AuthenticatedProjectProjectIdRoute,
  AuthenticatedSettingsAccessRoute: AuthenticatedSettingsAccessRoute,
  AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
  AuthenticatedSettingsCredentialsRoute: AuthenticatedSettingsCredentialsRoute,
  AuthenticatedSettingsDangerZoneRoute: AuthenticatedSettingsDangerZoneRoute,
  AuthenticatedSettingsEarningsRoute: AuthenticatedSettingsEarningsRoute,
  AuthenticatedSettingsEnvRoute: AuthenticatedSettingsEnvRoute,
  AuthenticatedSettingsMembersRoute: AuthenticatedSettingsMembersRoute,
  AuthenticatedSettingsNotificationsRoute:
    AuthenticatedSettingsNotificationsRoute,
  AuthenticatedSettingsPaymentsRoute: AuthenticatedSettingsPaymentsRoute,
  AuthenticatedSettingsPhoneNumbersRoute:
    AuthenticatedSettingsPhoneNumbersRoute,
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedSettingsProviderTiersRoute:
    AuthenticatedSettingsProviderTiersRoute,
  AuthenticatedSettingsResourcesRoute: AuthenticatedSettingsResourcesRoute,
  AuthenticatedSettingsSellerRoute: AuthenticatedSettingsSellerRoute,
  AuthenticatedSettingsStorageRoute: AuthenticatedSettingsStorageRoute,
  AuthenticatedSettingsSupervisionRoute: AuthenticatedSettingsSupervisionRoute,
  AuthenticatedSettingsTelegramRoute: AuthenticatedSettingsTelegramRoute,
  AuthenticatedSettingsUsageRoute: AuthenticatedSettingsUsageRoute,
  AuthenticatedSettingsUsersRoute: AuthenticatedSettingsUsersRoute,
  AuthenticatedSettingsWorkspaceRoute: AuthenticatedSettingsWorkspaceRoute,
  AuthenticatedUniversityPatternsRoute: AuthenticatedUniversityPatternsRoute,
  AuthenticatedArchitectIndexRoute: AuthenticatedArchitectIndexRoute,
  AuthenticatedBrainIndexRoute: AuthenticatedBrainIndexRoute,
  AuthenticatedCompanyIndexRoute: AuthenticatedCompanyIndexRoute,
  AuthenticatedConstitutionIndexRoute: AuthenticatedConstitutionIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedDepartmentsIndexRoute: AuthenticatedDepartmentsIndexRoute,
  AuthenticatedGoalsIndexRoute: AuthenticatedGoalsIndexRoute,
  AuthenticatedPrinciplesIndexRoute: AuthenticatedPrinciplesIndexRoute,
  AuthenticatedStrategyIndexRoute: AuthenticatedStrategyIndexRoute,
  AuthenticatedUniversityIndexRoute: AuthenticatedUniversityIndexRoute,
  AuthenticatedArchitectRunRunIdRoute: AuthenticatedArchitectRunRunIdRoute,
  AuthenticatedBillingMockPortalRefRoute:
    AuthenticatedBillingMockPortalRefRoute,
  AuthenticatedBrainEntityEntityIdRoute: AuthenticatedBrainEntityEntityIdRoute,
  AuthenticatedCheckoutMockRefRoute: AuthenticatedCheckoutMockRefRoute,
  AuthenticatedConnectMockRefRoute: AuthenticatedConnectMockRefRoute,
  AuthenticatedUniversityAbTestsTestIdRoute:
    AuthenticatedUniversityAbTestsTestIdRoute,
  AuthenticatedUniversityAbTestsNewRoute:
    AuthenticatedUniversityAbTestsNewRoute,
  AuthenticatedUniversityMarketplaceSkillIdRoute:
    AuthenticatedUniversityMarketplaceSkillIdRoute,
  AuthenticatedUniversitySkillsSkillIdRoute:
    AuthenticatedUniversitySkillsSkillIdRoute,
  AuthenticatedUniversityTrainingSessionIdRoute:
    AuthenticatedUniversityTrainingSessionIdRoute,
  AuthenticatedUniversityTunersTunerIdRoute:
    AuthenticatedUniversityTunersTunerIdRoute,
  AuthenticatedUniversityAbTestsIndexRoute:
    AuthenticatedUniversityAbTestsIndexRoute,
  AuthenticatedUniversityMarketplaceIndexRoute:
    AuthenticatedUniversityMarketplaceIndexRoute,
  AuthenticatedUniversitySkillsIndexRoute:
    AuthenticatedUniversitySkillsIndexRoute,
  AuthenticatedUniversityTrainingIndexRoute:
    AuthenticatedUniversityTrainingIndexRoute,
  AuthenticatedUniversityTunersIndexRoute:
    AuthenticatedUniversityTunersIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
